import { Suspense, lazy, startTransition, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import airplane_icon from '../../assets/airplane.png';
import hotel_icon from '../../assets/hotel_icon.png';
import train_homepage_icon from '../../assets/train_homepage_icon.png';
import weekend_getaways_icon from '../../assets/weekend_getaway.png';
import slugify from '../../utils/slugify';
import PageHelmet from '../SEO/PageHelmet';
import { shouldRenderHomepageMascot } from './homepageMascot';
import { MOBILE_HOMEPAGE_LAYOUT as L } from './mobileHomepageLayout';
import './styles/Homepage.css';
// import LanguageIcon from '@mui/icons-material/Language';
import seasonal_icon from '../../assets/seasonal_icon.png';

import {
  Add as AddIcon,
  AutoAwesome,
  Close as CloseIcon
} from '@mui/icons-material';
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Typography,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { fetchData } from '../../apiconfig';
import elephant_image from '../../assets/elephant_image.png';
import playicon from '../../assets/PlayIcon.png';
import visa_free_icon from '../../assets/visa_free.png';
import woman_icon_without_bg from '../../assets/woman_icon_without_bg.png';
import { BACKEND_URL } from '../../config/backendConfig';
import { searchAirports } from '../../services/airportApi';
import FlightForm from './FlightForm';
import HotelForm from './HotelForm';
import TrainForm from './TrainForm';
import FlightOneWayRoundTripSearchBar from './FlightOneWayRoundTripSearchBar';
// import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useLocation, useNavigate } from 'react-router-dom';
import arrowSquareLeft from '../../assets/arrow-square-left.svg';
import arrowSquareRight from '../../assets/arrow-square-right.svg';
import trending_trips_around_you_icon from '../../assets/trending_trips_around_you_icon.png';
import { useAuth } from '../../context/AuthContext';
import { SEO_DEFAULTS } from '../../config/companyConfig';
import { FAQ_TRUST_ITEMS, HOME_FAQS } from '../../config/faqContent';
import { FAQ_COLOR, HOME_FAQ_PREVIEW_COUNT } from '../common/faq.constants';
import FAQJsonLd from '../common/FAQJsonLd';
import MountWhenOpened from '../common/MountWhenOpened';
import { buildHomepageSchema } from '../../content/seo/schema/homepage';
import { useSearchContext } from '../../context/SearchContext';
import { findNearestAirports } from '../../services/airportApi';
import { getTextStyle } from '../../theme';
import {
  formTypeAfterHomepageNavigation,
  formTypeFromHomepagePath,
  homepageFormTypeFromStorage,
} from '../Header/homepageTabChange';
import MobileHeader from '../Header/MobileHeader';
import YovoTripHeader from '../Header/YovoTripHeader';
import MobileBottomNav from './MobileBottomNav';
import YovoImage from '../common/YovoImage';
import { destinationImageProps } from '../common/yovoImageSources';
import NearViewport from './NearViewport';
import WindowedCarouselTrack from './WindowedCarouselTrack';
import { applyHomepageSections } from './homepageSections';
import { PRODUCTS } from '../campaigns/config/products';
import { HOST_GROTESK_FAMILY } from '../../theme/tokens/typography';

const LoginModal = lazy(() => import('../Auth/LoginModal'));
const SignupModal = lazy(() => import('../Auth/SignupModal'));
const MobileChatbotOverlay = lazy(() => import('./MobileChatbotOverlay'));
const RegionalSettingsModal = lazy(() => import('./RegionalSettingsModal'));
const HomepagePopup = lazy(() => import('./HomepagePopup'));
const HomepageBannerCoordinator = lazy(() => import('./HomepageBannerCoordinator'));
const TestimonialsSection = lazy(() => import('../testimonials/TestimonialsSection'));
const FAQTrustStrip = lazy(() => import('../common/FAQTrustStrip'));
const FAQSection = lazy(() => import('../common/FAQSection'));
const GlobalFooter = lazy(() => import('../common/GlobalFooter/GlobalFooter'));

/**
 * Revert mobile chatbot: set to `true` to show the fixed right chatbot sidebar again on small viewports.
 * When `false`, sidebar only renders from the `md` breakpoint up (tablet/desktop).
 */
const SHOW_CHATBOT_SIDEBAR_ON_MOBILE = false;

/** One card + flex gap per arrow click; uses live DOM width for all breakpoints. */
function scrollHomepageCarouselByOneCard(containerId, directionSign) {
  const container = document.getElementById(containerId);
  if (!container) return;
  const card = container.querySelector('[data-carousel-card]') || container.firstElementChild;
  if (!card) return;
  const styles = getComputedStyle(container);
  const rawGap = styles.columnGap || styles.gap || '0';
  const gapStr = String(rawGap).trim().split(/\s+/)[0];
  const gapPx = parseFloat(gapStr) || 0;
  const delta = card.getBoundingClientRect().width + gapPx;
  if (delta <= 0) return;
  container.scrollBy({ left: directionSign * delta, behavior: 'smooth' });
}

/** Inline arrows sit in the grey card (no absolute, no z-index over page scrollbar). */
const homepageCarouselArrowIconButtonSx = {
  flexShrink: 0,
  display: 'flex',
  padding: '8px',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  border: '1px solid #A6A6A6',
  backgroundColor: '#FBFBFB',
  boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.12)',
  width: '40px',
  height: '40px',
  '&:hover': { backgroundColor: '#F0F0F0' },
};

// OLD PLACEHOLDER FAQs - TO BE REMOVED
const homepageFaqItems_OLD = [
  {
    question: 'How can I cancel or reschedule my booking?',
    answer: 'You can cancel or reschedule your booking by going to the “My Trips” section after logging into your account. Select your booking and choose either the “Cancel” or “Reschedule” option. Applicable airline charges and fare differences may apply depending on the ticket policy.',
  },
  {
    question: 'When will I receive my ticket confirmation?',
    answer: 'Your ticket confirmation is usually sent after payment is completed. We will replace this placeholder with live FAQ content once the dynamic source is connected.',
  },
  {
    question: 'Are there any hidden charges during checkout?',
    answer: 'All payable charges will be shown clearly before checkout. This dummy response can later be updated from the FAQ API or CMS.',
  },
  {
    question: 'How long do refunds usually take?',
    answer: 'Refund timelines depend on the airline, hotel, or travel partner policy. The final dynamic copy can include exact provider-specific timelines.',
  },
  {
    question: 'Can I change passenger details after booking?',
    answer: 'Some passenger details may be editable depending on supplier rules. This placeholder keeps the accordion ready for future integration.',
  },
  {
    question: 'What happens if my flight gets delayed or cancelled?',
    answer: 'If a flight is delayed or cancelled, available options depend on the airline policy and fare rules. Dynamic support content can be added here later.',
  },
  {
    question: 'How do I apply coupon codes or travel credits?',
    answer: 'Coupon codes and travel credits can be applied during checkout where eligible. This is temporary dummy content for the homepage FAQ section.',
  },
];

// Old FAQ styles removed - using FAQSection component styles now

const Homepage = () => {
  // State for managing flight form data
  // console.log("Homepage On state change:")
  const [flightFormState, setFlightFormState] = useState({
    tripType: 'oneway',
    multiCitySegments: []
  });

  const location = useLocation();
  const navigate = useNavigate();

  // State to manage active form type — URL path takes priority over localStorage
  const [activeFormType, setActiveFormType] = useState(() => {
    const path = location.pathname;
    if (path === '/flights') return 'flight';
    if (path === '/hotels') return 'hotel';
    if (path === '/trains') return 'train';
    const savedActiveForm = localStorage.getItem('yovo_active_form_type');
    return savedActiveForm || 'flight';
  });
  const handleFlightFormStateChange = useCallback((newState) => {
    // console.log("Prateek nair")
    setFlightFormState(newState);
  }, []);

  // Handle train form state changes
  const handleTrainFormStateChange = useCallback((newState) => {
    // Similar to flight form state handling
    // State change handled silently
  }, []);

  // Handle hotel form state changes
  const handleHotelFormStateChange = useCallback((newState) => {
    // Similar to flight form state handling
    // State change handled silently
  }, []);

  // Handle auth required callback - memoized to prevent re-renders
  const handleAuthRequired = useCallback(() => {
    setLoginModalOpen(true);
  }, []);

  // Memoized callbacks for modals to prevent re-renders
  const handleCloseLoginModal = useCallback(() => {
    setLoginModalOpen(false);
  }, []);

  const handleSwitchToSignup = useCallback(() => {
    setLoginModalOpen(false);
    setSignupModalOpen(true);
  }, []);

  const handleCloseSignupModal = useCallback(() => {
    setSignupModalOpen(false);
  }, []);

  const formTypeToPath = { flight: '/flights', hotel: '/hotels', train: '/trains' };
  /** Tab the user just tapped. The old URL must not paint over it. */
  const requestedFormTypeRef = useRef(null);

  // Function to switch between forms — updates URL, localStorage, and cross-tab sync
  const switchToForm = useCallback((formType) => {
    requestedFormTypeRef.current = formType;
    setActiveFormType(formType);
    localStorage.setItem('yovo_active_form_type', formType);
    window.dispatchEvent(new CustomEvent('localStorageChange', {
      detail: { key: 'yovo_active_form_type', newValue: formType },
    }));
    const targetPath = formTypeToPath[formType] || '/flights';
    if (location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, [location.pathname, navigate]);

  /** Pathname wins on /flights, /hotels, /trains; localStorage only on generic routes.
   *  A tap keeps its tab until the URL matches, so the page cannot flash the old tab. */
  useEffect(() => {
    const path = location.pathname;
    const formFromPath = formTypeFromHomepagePath(path);
    const requestedFormType = requestedFormTypeRef.current;
    const nextFormType = formTypeAfterHomepageNavigation(formFromPath, requestedFormType);
    if (requestedFormType && nextFormType === requestedFormType && formFromPath === requestedFormType) {
      requestedFormTypeRef.current = null;
    }

    if (nextFormType) {
      setActiveFormType(nextFormType);
      if (localStorage.getItem('yovo_active_form_type') !== nextFormType) {
        localStorage.setItem('yovo_active_form_type', nextFormType);
      }
      return;
    }

    const savedActiveForm = localStorage.getItem('yovo_active_form_type');
    if (savedActiveForm) {
      setActiveFormType(savedActiveForm);
    }
  }, [location.pathname]);

  // Listen for storage changes (when header updates localStorage)
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key !== 'yovo_active_form_type' || !e.newValue) return;
      const next = homepageFormTypeFromStorage(formTypeFromHomepagePath(location.pathname), e.newValue);
      if (!next) return;
      setActiveFormType(next);
    };

    /** Same-tab sync: YovoTripHeader dispatches this when user taps Flights/Trains/Stays (storage event only fires across tabs). */
    const handleLocalStorageCustom = (e) => {
      const stored = e.detail?.newValue;
      if (e.detail?.key !== 'yovo_active_form_type' || !stored) return;
      const next = homepageFormTypeFromStorage(formTypeFromHomepagePath(location.pathname), stored);
      if (!next) return;
      setActiveFormType(next);
    };

    const checkLocalStorage = () => {
      const next = homepageFormTypeFromStorage(
        formTypeFromHomepagePath(location.pathname),
        localStorage.getItem('yovo_active_form_type'),
      );
      if (next && next !== activeFormType) {
        setActiveFormType(next);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('localStorageChange', handleLocalStorageCustom);
    window.addEventListener('focus', checkLocalStorage);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('localStorageChange', handleLocalStorageCustom);
      window.removeEventListener('focus', checkLocalStorage);
    };
  }, [location.pathname, activeFormType]);

  // Custom styles for React DatePicker
  const datePickerStyles = `
    .custom-datepicker {
      border: none !important;
      box-shadow: none !important;
      font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
      width: 100% !important;
    }
    
    .custom-datepicker .react-datepicker__header {
      background-color: #000 !important;
      border-bottom: 1px solid #333 !important;
      border-radius: 6px 6px 0 0 !important;
      padding: 8px 0 !important;
    }
    
    .custom-datepicker .react-datepicker__current-month {
      color: #fff !important;
      font-weight: 600 !important;
      font-size: 16px !important;
    }
    
    .custom-datepicker .react-datepicker__day-name {
      color: #666 !important;
      font-weight: 500 !important;
      font-size: 11px !important;
      width: calc(100% / 7 - 1px) !important;
      flex: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0.5px !important;
      height: 24px !important;
      line-height: 22px !important;
    }
    
    .custom-datepicker .react-datepicker__day {
      color: #333 !important;
      font-weight: 400 !important;
      border-radius: 3px !important;
      margin: 0.5px !important;
      width: calc(100% / 7 - 1px) !important;
      height: 32px !important;
      line-height: 30px !important;
      flex: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      font-size: 13px !important;
    }
    
    .custom-datepicker .react-datepicker__day:hover {
      background-color: #f0f0f0 !important;
      color: #000 !important;
    }
    
    .custom-datepicker .react-datepicker__day--selected {
      background-color: #000 !important;
      color: white !important;
    }
    
    .custom-datepicker .react-datepicker__day--in-selecting-range {
      background-color: #f0f0f0 !important;
      color: #000 !important;
    }
    
    .custom-datepicker .react-datepicker__day--in-range {
      background-color: #f0f0f0 !important;
      color: #000 !important;
    }
    
    .custom-datepicker .react-datepicker__day--range-start,
    .custom-datepicker .react-datepicker__day--range-end {
      background-color: #000 !important;
      color: white !important;
    }
    
    .custom-datepicker .react-datepicker__day--disabled {
      color: #ccc !important;
    }
    
    .custom-datepicker .react-datepicker__navigation {
      top: 8px !important;
    }
    
    .custom-datepicker .react-datepicker__navigation--previous {
      left: 8px !important;
    }
    
    .custom-datepicker .react-datepicker__navigation--next {
      right: 8px !important;
    }
    
    .custom-datepicker .react-datepicker__navigation-icon::before {
      border-color: #fff !important;
    }
    
    .custom-datepicker .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
      border-color: #ccc !important;
    }
    
    .custom-datepicker .react-datepicker__month-container {
      width: 100% !important;
    }
    
    .custom-datepicker .react-datepicker__month {
      width: 100% !important;
    }
    
    .custom-datepicker .react-datepicker__week {
      width: 100% !important;
      display: flex !important;
      justify-content: space-between !important;
    }
    
    .custom-datepicker .react-datepicker__day-names {
      width: 100% !important;
      display: flex !important;
      justify-content: space-between !important;
    }

    /* Two Month Calendar Styles */
    .custom-datepicker-two-month {
      border: none !important;
      box-shadow: none !important;
      font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
      width: 100% !important;
    }
    
    .custom-datepicker-two-month .react-datepicker {
      display: flex !important;
      flex-direction: row !important;
      gap: 12px !important;
      align-items: flex-start !important;
      padding: 0 !important;
      width: 100% !important;
    }
    
    
    .custom-datepicker-two-month .react-datepicker__header {
      background-color: transparent !important;
      border-bottom: none !important;
      padding: 0 !important;
      margin-bottom: 8px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__current-month {
      color: #000 !important;
      font-weight: 600 !important;
      font-size: 13px !important;
      margin-bottom: 8px !important;
      text-align: center !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day-names {
      display: flex !important;
      justify-content: space-between !important;
      margin-bottom: 4px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day-name {
      color: #545665 !important;
      font-weight: 600 !important;
      font-size: 10px !important;
      text-transform: uppercase !important;
      margin: 0 !important;
      padding: 4px 0 !important;
      width: 28px !important;
      text-align: center !important;
      flex: 1 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__month {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__week {
      display: flex !important;
      justify-content: space-between !important;
      margin: 0 !important;
      margin-bottom: 2px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day {
      color: #333 !important;
      font-weight: 500 !important;
      font-size: 11px !important;
      border-radius: 0 !important;
      margin: 0 !important;
      width: 28px !important;
      height: 28px !important;
      line-height: 28px !important;
      text-align: center !important;
      flex: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day:hover {
      background-color: #f5f5f5 !important;
      color: #333 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--selected {
      background-color: #ab2645 !important;
      color: #fff !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--in-selecting-range {
      background-color: rgba(171, 38, 69, 0.1) !important;
      color: #333 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--in-range {
      background-color: rgba(171, 38, 69, 0.1) !important;
      color: #333 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--range-start {
      background-color: #ab2645 !important;
      color: #fff !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--range-end {
      background-color: #ab2645 !important;
      color: #fff !important;
    }
    
    /* Remove any unwanted blue highlighting */
    .custom-datepicker-two-month .react-datepicker__day--highlighted {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--highlighted-custom-1,
    .custom-datepicker-two-month .react-datepicker__day--highlighted-custom-2 {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    /* Ensure only actual selected dates are highlighted */
    .custom-datepicker-two-month .react-datepicker__day--selected:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: #ab2645 !important;
      color: #fff !important;
    }
    
    /* Prevent highlighting same date in different months for one-way trips */
    .custom-datepicker-two-month .react-datepicker__month-container:nth-child(2) .react-datepicker__day--selected {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    /* Only highlight selected date in the first month for one-way trips */
    .custom-datepicker-two-month .react-datepicker__month-container:first-child .react-datepicker__day--selected {
      background-color: #ab2645 !important;
      color: #fff !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--outside-month {
      visibility: hidden !important;
      pointer-events: none !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--selected.react-datepicker__day--outside-month {
      background-color: transparent !important;
      color: transparent !important;
      visibility: hidden !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--disabled {
      color: #ccc !important;
      background-color: transparent !important;
      cursor: not-allowed !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day[aria-disabled="true"] {
      color: #ccc !important;
      background-color: transparent !important;
      cursor: not-allowed !important;
    }
    
    /* Remove any default browser highlighting */
    .custom-datepicker-two-month .react-datepicker__day:focus {
      outline: none !important;
      background-color: transparent !important;
    }
    
    /* Ensure clean date selection without cross-month interference */
    .custom-datepicker-two-month .react-datepicker__day--keyboard-selected {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    /* Remove any default active states */
    .custom-datepicker-two-month .react-datepicker__day:active {
      background-color: transparent !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation {
      background-color: transparent !important;
      border: none !important;
      color: #ab2645 !important;
      width: 20px !important;
      height: 20px !important;
      border-radius: 3px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      top: 0 !important;
    }
    
    /* Responsive navigation container sizing for two-month calendar */
    @media (max-width: 1024px) {
      .custom-datepicker-two-month .react-datepicker__navigation {
        width: 18px !important;
        height: 18px !important;
      }
    }
    
    @media (max-width: 480px) {
      .custom-datepicker-two-month .react-datepicker__navigation {
        width: 16px !important;
        height: 16px !important;
      }
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation:hover {
      background-color: rgba(171, 38, 69, 0.1) !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation--previous {
      left: 8px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation--next {
      right: 8px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation-icon::before {
      border-color: #ab2645 !important;
      border-width: 3px 3px 0 0 !important;
      width: 6px !important;
      height: 6px !important;
    }
    
    /* Responsive arrow sizing for two-month calendar */
    @media (max-width: 1024px) {
      .custom-datepicker-two-month .react-datepicker__navigation-icon::before {
        width: 5px !important;
        height: 5px !important;
        border-width: 2.5px 2.5px 0 0 !important;
      }
    }
    
    @media (max-width: 480px) {
      .custom-datepicker-two-month .react-datepicker__navigation-icon::before {
        width: 4px !important;
        height: 4px !important;
        border-width: 2px 2px 0 0 !important;
      }
    }
    
    .custom-datepicker-two-month .react-datepicker__month-container {
      background-color: #fff !important;
      border-radius: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      min-width: 180px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__month-wrapper {
      display: flex !important;
      flex-direction: row !important;
      gap: 12px !important;
      align-items: flex-start !important;
      width: 100% !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__month-container {
      background-color: #fff !important;
      border-radius: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      width: auto !important;
      min-width: 180px !important;
      display: inline-block !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__month-container + .react-datepicker__month-container {
      margin-left: 12px !important;
    }

    /* Single Month Calendar Styles (for one-way trips) */
    .custom-datepicker-single-month {
      border: none !important;
      box-shadow: none !important;
      font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
      width: 100% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker {
      display: flex !important;
      justify-content: center !important;
      padding: 0 !important;
      width: 100% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__header {
      background-color: transparent !important;
      border-bottom: none !important;
      padding: 0 !important;
      margin-bottom: 8px !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__current-month {
      color: #000 !important;
      font-weight: 600 !important;
      font-size: 13px !important;
      margin-bottom: 8px !important;
      text-align: center !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day-names {
      display: flex !important;
      justify-content: space-between !important;
      margin-bottom: 4px !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day-name {
      color: #545665 !important;
      font-weight: 600 !important;
      font-size: 11px !important;
      text-transform: uppercase !important;
      margin: 0 !important;
      padding: 2px 0 !important;
      width: 40px !important;
      text-align: center !important;
      flex: 1 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__month {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__week {
      display: flex !important;
      justify-content: space-between !important;
      margin: 0 !important;
      margin-bottom: 2px !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day {
      color: #333 !important;
      font-weight: 500 !important;
      font-size: 12px !important;
      border-radius: 0 !important;
      margin: 0 !important;
      width: 40px !important;
      height: 42px !important;
      line-height: 1.2 !important;
      text-align: center !important;
      flex: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 2px 0 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day:hover {
      background-color: #f5f5f5 !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--selected {
      background-color: #ab2645 !important;
      color: #fff !important;
      border-radius: 25% !important;
    }
    
    /* Remove ALL blue highlighting */
    .custom-datepicker-single-month .react-datepicker__day--highlighted {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--highlighted-custom-1,
    .custom-datepicker-single-month .react-datepicker__day--highlighted-custom-2 {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--keyboard-selected {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--today {
      background-color: transparent !important;
      color: #333 !important;
      font-weight: 500 !important;
    }
    
    /* Range selection styles for round-trip - only for middle dates */
    .custom-datepicker-single-month .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: rgba(171, 38, 69, 0.1) !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: rgba(171, 38, 69, 0.1) !important;
      color: #333 !important;
    }
    
    /* CRITICAL: Range start MUST show as red, even when in-selecting-range */
    /* This ensures first selected date shows as selected (red), not range color (pink) */
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range:hover {
      background-color: #ab2645 !important;
      background: #ab2645 !important;
      color: #fff !important;
      font-weight: 700 !important;
      border-radius: 25% !important;
    }
    
    /* Range start and end should override in-range styles - MUST come after in-selecting-range */
    .custom-datepicker-single-month .react-datepicker__day--range-start,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-range {
      background-color: #ab2645 !important;
      background: #ab2645 !important;
      color: #fff !important;
      font-weight: 700 !important;
      border-radius: 25% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--range-end,
    .custom-datepicker-single-month .react-datepicker__day--range-end.react-datepicker__day--in-range {
      background-color: #ab2645 !important;
      color: #fff !important;
      font-weight: 700 !important;
      border-radius: 25% !important;
    }
    
    /* Ensure the text is white and visible */
    .custom-datepicker-single-month .react-datepicker__day--range-start:hover,
    .custom-datepicker-single-month .react-datepicker__day--range-end:hover {
      background-color: #ab2645 !important;
      color: #fff !important;
    }
    
    /* Override general hover for selected dates */
    .custom-datepicker-single-month .react-datepicker__day--range-start:hover,
    .custom-datepicker-single-month .react-datepicker__day--range-end:hover {
      background-color: #ab2645 !important;
      color: #fff !important;
      border-radius: 25% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--disabled {
      color: #ccc !important;
      background-color: transparent !important;
      cursor: not-allowed !important;
    }
    .custom-datepicker-single-month .react-datepicker__day--disabled span {
      color: #ccc !important;
    }
    .custom-datepicker-single-month .react-datepicker__day--selected span,
    .custom-datepicker-single-month .react-datepicker__day--range-start span,
    .custom-datepicker-single-month .react-datepicker__day--range-end span {
      color: #fff !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--outside-month {
      visibility: hidden !important;
      pointer-events: none !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--outside-month {
      background-color: transparent !important;
      color: transparent !important;
      visibility: hidden !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation {
      background-color: transparent !important;
      border: none !important;
      color: #ab2645 !important;
      width: 24px !important;
      height: 24px !important;
      border-radius: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      top: 0 !important;
      padding: 0 !important;
    }
    
    /* Responsive navigation container sizing for single-month calendar */
    @media (max-width: 1024px) {
      .custom-datepicker-single-month .react-datepicker__navigation {
        width: 22px !important;
        height: 22px !important;
      }
    }
    
    @media (max-width: 480px) {
      .custom-datepicker-single-month .react-datepicker__navigation {
        width: 20px !important;
        height: 20px !important;
      }
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation:hover {
      background-color: rgba(171, 38, 69, 0.1) !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation--previous {
      left: 8px !important;
      background-image: url(${arrowSquareLeft}) !important;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation--next {
      right: 8px !important;
      background-image: url(${arrowSquareRight}) !important;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation-icon {
      display: none !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation-icon::before {
      display: none !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__month-container {
      background-color: #fff !important;
      border-radius: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      min-width: 200px !important;
    }
    
    /* Nuclear option - override ALL possible blue highlighting */
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: rgb(0, 123, 255)"],
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: #007bff"],
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: blue"],
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: rgb(0, 123, 255)"],
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: #007bff"] {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    /* Override any inline styles that might be added by React DatePicker */
    .custom-datepicker-single-month .react-datepicker__day {
      background-color: transparent !important;
    }
    
    /* Ensure range selection takes priority over the nuclear option */
    /* CRITICAL: This selector applies border-radius, so use same one for color */
    .custom-datepicker-single-month .react-datepicker__day--selected,
    .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--in-selecting-range,
    .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--range-start {
      background-color: #ab2645 !important;
      background: #ab2645 !important;
      color: #fff !important;
      border-radius: 25% !important;
    }
    
    /* Range start and end should override in-range styles - higher specificity */
    /* CRITICAL: Force red color for range-start, even with inline styles */
    .custom-datepicker-single-month .react-datepicker__day--range-start,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-range,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--selected {
      background-color: #ab2645 !important;
      background: #ab2645 !important;
      color: #fff !important;
      border-radius: 25% !important;
      font-weight: 700 !important;
    }
    
    /* Force override any inline styles on range-start */
    .custom-datepicker-single-month .react-datepicker__day--range-start[style],
    .custom-datepicker-single-month .react-datepicker__day--selected[style] {
      background-color: #ab2645 !important;
      background: #ab2645 !important;
      color: #fff !important;
    }
    
    /* Override the specific rgba color that might be applied inline */
    .custom-datepicker-single-month .react-datepicker__day--range-start[style*="rgba(171, 38, 69, 0.1)"],
    .custom-datepicker-single-month .react-datepicker__day--range-start[style*="background-color: rgba"],
    .custom-datepicker-single-month .react-datepicker__day--selected[style*="rgba(171, 38, 69, 0.1)"],
    .custom-datepicker-single-month .react-datepicker__day--selected[style*="background-color: rgba"] {
      background-color: #ab2645 !important;
      background: #ab2645 !important;
      color: #fff !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--range-end,
    .custom-datepicker-single-month .react-datepicker__day--range-end.react-datepicker__day--in-range {
      background-color: #ab2645 !important;
      color: #fff !important;
      border-radius: 25% !important;
      font-weight: 700 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--in-range:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: rgba(171, 38, 69, 0.1) !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: rgba(171, 38, 69, 0.1) !important;
      color: #333 !important;
    }

    /* Mobile fullscreen date sheet — Figma tokens; must follow legacy single-month rules above */
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__current-month {
      font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
      font-size: 20px !important;
      font-weight: 700 !important;
      color: #252637 !important;
      line-height: 28px !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__week {
      display: grid !important;
      grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
      width: 100% !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day {
      width: 100% !important;
      max-width: none !important;
      min-width: 0 !important;
      height: auto !important;
      min-height: 48px !important;
      flex: none !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      color: #434151 !important;
      border-radius: 0 !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start:hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end:hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-range,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end.react-datepicker__day--in-range,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--selected,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--selected:hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start[style],
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end[style],
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--selected[style] {
      background-color: #cf2048 !important;
      background: #cf2048 !important;
      color: #fff !important;
      font-weight: 700 !important;
      border-radius: 3px !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start:not(.react-datepicker__day--range-end) {
      border-radius: 3px 0 0 3px !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end:not(.react-datepicker__day--range-start) {
      border-radius: 0 3px 3px 0 !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)[style],
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)[style] {
      background-color: rgba(255, 222, 229, 0.56) !important;
      background: rgba(255, 222, 229, 0.56) !important;
      color: #434151 !important;
      border-radius: 0 !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:first-child,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:first-child,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:first-child {
      color: #fff !important;
    }

    /* Gradient border rotation animation */
    @keyframes gradientRotate {
      0% {
        background-image: linear-gradient(white, white), linear-gradient(90deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
      25% {
        background-image: linear-gradient(white, white), linear-gradient(180deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
      50% {
        background-image: linear-gradient(white, white), linear-gradient(270deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
      75% {
        background-image: linear-gradient(white, white), linear-gradient(360deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
      100% {
        background-image: linear-gradient(white, white), linear-gradient(450deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
    }

    .gradient-border-animate {
      animation: gradientRotate 2s ease-in-out 1;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `;

  const [tab, setTab] = useState(0);
  const [showNearbyFrom, setShowNearbyFrom] = useState(true);
  const [showNearbyTo, setShowNearbyTo] = useState(true);
  const [showAlternate, setShowAlternate] = useState(true);
  const [passengers, setPassengers] = useState('1 Adult 0 Children');
  const [travelClass, setTravelClass] = useState('ECONOMY');
  const [showPassengerDropdown, setShowPassengerDropdown] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [calendarPrices, setCalendarPrices] = useState({});
  const [priceLoading, setPriceLoading] = useState(false);
  const [numAdults, setNumAdults] = useState(1);
  const [numChildren, setNumChildren] = useState(0);
  const [numInfants, setNumInfants] = useState(0);
  const [chatbotOpen, setChatbotOpen] = useState(false);
  const [chatbotInputText, setChatbotInputText] = useState('');
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
  const showHomepageChatbotSidebar = SHOW_CHATBOT_SIDEBAR_ON_MOBILE || isMdUp;
  const [fromInput, setFromInput] = useState('');
  const [toInput, setToInput] = useState('');
  const [fromOptions, setFromOptions] = useState([]);
  const [toOptions, setToOptions] = useState([]);

  // Debug fromOptions changes
  useEffect(() => {
    // console.log('🔍 fromOptions changed to:', fromOptions.length);
  }, [fromOptions]);
  const [fromAirport, setFromAirport] = useState(null);
  const [toAirport, setToAirport] = useState(null);
  const [fromLoading, setFromLoading] = useState(false);
  const [toLoading, setToLoading] = useState(false);
  const [fromDropdownOpen, setFromDropdownOpen] = useState(false);
  const [toDropdownOpen, setToDropdownOpen] = useState(false);
  const [greeting, setGreeting] = useState('');
  const [geoState, setGeoState] = useState('');
  const [country, setCountry] = useState('');
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [userIP, setUserIP] = useState('');
  const [showTranslate, setShowTranslate] = useState(false);
  const [userLocation, setUserLocation] = useState(null);
  const [nearestAirport, setNearestAirport] = useState(null);
  const [locationLoading, setLocationLoading] = useState(false);
  const [tripType, setTripType] = useState('oneway'); // 'oneway' or 'roundtrip'

  const [showNearbyAirports, setShowNearbyAirports] = useState(true);
  const [smartRecommendations, setSmartRecommendations] = useState(false);
  const [autoUpgradation, setAutoUpgradation] = useState(false);

  useEffect(() => {
    if (tripType === 'oneway') {
      setEndDate(null);
    }
  }, [tripType]);
  
  const inputWidth = 572;
  const fullText = "Hey, It's Yovo, your AI travel guide. How can I help you today?";
  const [visibleText, setVisibleText] = useState(fullText); // Always show full text, no animation
  const [popular_places, setPopular_places] = useState([]);
  const [trending_international_destinations, setTrending_international_destinations] = useState([]);
  const [weekend_getaways, setWeekend_getaways] = useState([]);
  const [visa_free_destinations, setVisa_free_destinations] = useState([]);
  const [seasonal_destinations, setSeasonal_destinations] = useState([]);
  const [trending_trips,setTrending_trips] = useState([]);
  const [sectionMeta, setSectionMeta] = useState({});

  const [currentDestinationIndex, setCurrentDestinationIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [previousImageUrl, setPreviousImageUrl] = useState('');
  const [gradientAnimationPlayed, setGradientAnimationPlayed] = useState(false);
  const aiGuideContentRef = useRef(null);
  const [aiGuideContentHeight, setAiGuideContentHeight] = useState(null);
  const [regionalSettingsOpen, setRegionalSettingsOpen] = useState(false);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [signupModalOpen, setSignupModalOpen] = useState(false);
  // Get authentication status
  const { isAuthenticated } = useAuth();

  // Create array of first items from each of the 5 sections for Popular Places
  const popularPlacesFromSections = useMemo(() => {
    const sections = [];
    
    // Get first item from each section if available
    if (trending_trips && trending_trips.length > 0) {
      sections.push(trending_trips[0]);
    }
    if (trending_international_destinations && trending_international_destinations.length > 0) {
      sections.push(trending_international_destinations[0]);
    }
    if (weekend_getaways && weekend_getaways.length > 0) {
      sections.push(weekend_getaways[0]);
    }
    if (visa_free_destinations && visa_free_destinations.length > 0) {
      sections.push(visa_free_destinations[0]);
    }
    if (seasonal_destinations && seasonal_destinations.length > 0) {
      sections.push(seasonal_destinations[0]);
    }
    
    return sections;
  }, [trending_trips, trending_international_destinations, weekend_getaways, visa_free_destinations, seasonal_destinations]);

  // Helper function to handle chatbot input send
  const handleChatbotSend = () => {
    const msg = chatbotInputText.trim();
    if (!msg) return;
    if (!showHomepageChatbotSidebar) {
      window.chatbotInitialMessage = msg;
      setChatbotOpen(true);
    } else if (window.openChatbot) {
      window.openChatbot(msg);
    }
    setChatbotInputText('');
  };

  // Helper function to handle Enter key press
  const handleChatbotKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleChatbotSend();
    }
  };

  // Image list for the featured destination. Recomputed only when that destination changes.
  const availableImages = useMemo(() => {
    if (!trending_trips[currentDestinationIndex]?.output_json) return [];

    const destination = trending_trips[currentDestinationIndex].output_json;
    const images = [];
    
    // Add hero image
    if (destination.hero?.image) {
      images.push(destination.hero.image);
    }
    
    // Add attraction images
    if (destination.attractions?.sites) {
      destination.attractions.sites.forEach(site => {
        if (site.image) images.push(site.image);
      });
    }
    
    // Add historical sites images
    if (destination.history?.historicalSites) {
      destination.history.historicalSites.forEach(site => {
        if (site.image) images.push(site.image);
      });
    }
    
    // Add accommodation images
    if (destination.accommodation?.areas) {
      destination.accommodation.areas.forEach(area => {
        if (area.image) images.push(area.image);
      });
    }
    
    // Add food images
    if (destination.foodAndDrinks?.items) {
      destination.foodAndDrinks.items.forEach(item => {
        if (item.image) images.push(item.image);
      });
    }
    
    // Add transportation images
    if (destination.transportation?.options) {
      destination.transportation.options.forEach(option => {
        if (option.image) images.push(option.image);
      });
    }
    
    // Add best time to visit images
    if (destination.bestTimeToVisit?.seasons) {
      destination.bestTimeToVisit.seasons.forEach(season => {
        if (season.image) images.push(season.image);
      });
    }
    
    // Add next destinations images
    if (destination.nextDestinations) {
      destination.nextDestinations.forEach(dest => {
        if (dest.image) images.push(dest.image);
      });
    }
    
    return images.slice(0, 8); // Limit to first 8 images
  }, [trending_trips, currentDestinationIndex]);

  const currentImage = availableImages[currentImageIndex] || availableImages[0] || '';

  // Reset image index when destination changes
  useEffect(() => {
    setCurrentImageIndex(0);
    setPreviousImageUrl(''); // Reset previous image when destination changes
  }, [currentDestinationIndex]);

  // Auto-rotate images every 3 seconds with smooth transition
  useEffect(() => {
    if (availableImages.length <= 1) return undefined; // Don't rotate if there's only one or no images

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        const shownImage = availableImages[prevIndex] || availableImages[0] || '';
        setPreviousImageUrl(shownImage); // Store current image as previous
        
        const nextIndex = (prevIndex + 1) % availableImages.length;
        
        // Clear previous image after transition
        setTimeout(() => {
          setPreviousImageUrl('');
        }, 500); // Match transition duration
        
        return nextIndex;
      });
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [availableImages]);

  // Trigger gradient animation on mount
  useEffect(() => {
    setGradientAnimationPlayed(true);
  }, []);

  // Additional data for new sections
  const themedCollections = [
    {
      title: 'Pizza, Roman style',
      description: 'Classes and experiences for authentic pizza',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/0ae1484d45db31325bfaa0def617d0e20893c649?width=598'
    },
    {
      title: 'Get Right to the reef',
      description: 'Classes and experiences for authentic pizza',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/58f899549e414a4698a630d1793c7a243e0a0cb4?width=598'
    },
    {
      title: 'Take a grand Diversion',
      description: 'Classes and experiences for authentic pizza',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/b47897c9794d037a424155abcda767a5fc37755c?width=598'
    },
    {
      title: 'Pizza, Roman style',
      description: 'Classes and experiences for authentic pizza',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/672a1ba89245895921712844acb399678ff0356c?width=598'
    }
  ];

  const weekendGetaways = [
    {
      title: 'Small-group boat tour of the Amalfi Coast from Sorrento',
      description: 'Search Flights & Places Hire to our most popular destinations',
      price: 'from ₹16,128 per adult',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/f9d8f7fbf50d433ce27786a6d24ba8e2cde709d9?width=598'
    },
    {
      title: 'Small-group boat tour of the Amalfi Coast from Sorrento',
      description: 'Search Flights & Places Hire to our most popular destinations',
      price: 'from ₹16,128 per adult',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/06e939b8cf415bc7cd20acee9162273c20043482?width=598'
    },
    {
      title: 'Small-group boat tour of the Amalfi Coast from Sorrento',
      description: 'Search Flights & Places Hire to our most popular destinations',
      price: 'from ₹16,128 per adult',
      image: elephant_image
    },
    {
      title: 'Small-group boat tour of the Amalfi Coast from Sorrento',
      description: 'Search Flights & Places Hire to our most popular destinations',
      price: 'from ₹16,128 per adult',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/f2129dcd1ef2dfda6afaa5218babd8b5c3b841bb?width=598'
    }
  ];

  const interestCategories = [
    {
      title: 'Food',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/6dd6be8e7f506aaf68523aa4a23763ee7d11b9da?width=598'
    },
    {
      title: 'Water',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/060ad7747198e150e8d5a72cbafa85f6327d1865?width=598'
    },
    {
      title: 'Outdoors',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/b0a6ff8f2d3443313c293a8dd7014b7f52b37fc8?width=598'
    },
    {
      title: 'Culture',
      image: 'https://api.builder.io/api/v1/image/assets/TEMP/05cd614c0c9f46b02ef920a3bffc1a7c109b2e41?width=598'
    }
  ];

  // (Old section cache functions removed — using single API with sessionStorage cache now)

useEffect(() => {
  const fetchHomepageSections = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/destination/homepage-sections`);
      if (!res.ok) throw new Error('Failed to fetch homepage sections');
      const json = await res.json();

      if (json.success && json.sections) {
        const mapped = applyHomepageSections(json.sections);
        startTransition(() => {
          setSectionMeta(mapped.meta);
          setTrending_trips(mapped.trending);
          setTrending_international_destinations(mapped.international);
          setWeekend_getaways(mapped.weekend);
          setVisa_free_destinations(mapped.visaFree);
          setSeasonal_destinations(mapped.seasonal);
        });
      }
    } catch (error) {
      console.error('Error fetching homepage sections:', error);
      setTrending_trips([]);
      setTrending_international_destinations([]);
      setWeekend_getaways([]);
      setVisa_free_destinations([]);
      setSeasonal_destinations([]);
    }
  };

  fetchHomepageSections();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [])
  // Google Translate function
  const addGoogleTranslate = () => {
    if (!showTranslate) {
      const script = document.createElement('script');
      script.src = `//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit`;
      document.head.appendChild(script);
      
      window.googleTranslateElementInit = function() {
        new window.google.translate.TranslateElement({
          pageLanguage: 'en',
          includedLanguages: 'af,sq,am,ar,hy,as,ay,az,bm,eu,be,bn,bho,bs,bg,ca,ceb,ny,zh-cn,zh-tw,co,hr,cs,da,dv,doi,nl,eo,et,ee,tl,fi,fr,fy,gl,ka,de,el,gn,gu,ht,ha,haw,iw,hi,hmn,hu,is,ig,ilo,id,ga,it,ja,jw,kn,kk,km,rw,gom,ko,kri,ku,ckb,ky,lo,la,lv,ln,lt,lg,lb,mk,mai,mg,ms,ml,mt,mi,mr,mni-mtei,lus,mn,my,ne,no,or,om,ps,fa,pl,pt,pa,qu,ro,ru,sm,sa,gd,nso,sr,st,sn,sd,si,sk,sl,so,es,su,sw,sv,tg,ta,tt,te,th,ti,ts,tr,tk,ak,uk,ur,ug,uz,vi,cy,xh,yi,yo,zu',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE
        }, 'google_translate_element');
      };
      setShowTranslate(true);
    }
  };

  // Cache functions for IP/Location API
  const getLocationCacheKey = useCallback(() => {
    return 'homepage_user_location';
  }, []);

  const getCachedLocation = useCallback(() => {
    try {
      const cacheKey = getLocationCacheKey();
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsedCache = JSON.parse(cached);
        const cacheAge = Date.now() - parsedCache.timestamp;
        const maxAge = 24 * 60 * 60 * 1000; // 24 hours (location doesn't change often)
        if (cacheAge < maxAge) {
          return parsedCache.data;
        } else {
          sessionStorage.removeItem(cacheKey);
        }
      }
    } catch (error) {
      console.error('Error reading location cache:', error);
    }
    return null;
  }, [getLocationCacheKey]);

  const cacheLocation = useCallback((locationData) => {
    try {
      const cacheKey = getLocationCacheKey();
      const cacheData = {
        data: locationData,
        timestamp: Date.now()
      };
      sessionStorage.setItem(cacheKey, JSON.stringify(cacheData));
    } catch (error) {
      console.error('Error caching location:', error);
    }
  }, [getLocationCacheKey]);

  useEffect(() => {
    // Check cache first for user location
    const cachedLocation = getCachedLocation();
    if (cachedLocation) {
      console.log('✅ Using cached user location from sessionStorage');
      setUserLocation(cachedLocation.location);
      setUserIP(cachedLocation.ip);
      setGreeting("Hello " + cachedLocation.location.city);
      return;
    }

    // Get IP address
    var lattidue="";
    var longitude=""
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        // console.log('User IP Address:', data);
        const userIP = data.ip;
        fetch(`https://ipapi.co/${userIP}/json/`)
          .then(response => response.json())
          .then(data => {
            // console.log('City:', data.city);
            const locationData = {
              city: data.city,
              state: data.region,
              country: data.country_name,
              latitude: data.latitude,
              longitude: data.longitude
            };
            setUserLocation(locationData);
            setGreeting("Hello "+data.city);
            
            // Cache the location data
            cacheLocation({
              location: locationData,
              ip: userIP
            });
            
            fetchData('Store_Flight_Results', {
              Measure:"Location_Data",
              User_City:data.city,
              User_State:data.region,
              User_Country:data.country_name,
              User_Latitude:data.latitude,
              User_Longitude:data.longitude
            }).catch((error) => {
              console.error('Error storing location data:', error);
            });
            setUserIP(userIP);
          })
          .catch(error => console.log('Error fetching location:', error));
      })
      .catch(error => console.log('Error fetching IP:', error));
  // getCachedLocation and cacheLocation are stable useCallback functions
  // They don't need to be in dependencies as they're just utility functions
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(async (pos) => {
    //     const { latitude, longitude } = pos.coords;
    //     try {
    //       const res = await fetch(
    //         `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    //       );
    //       const data = await res.json();
    //       const state = data.address?.state || '';
    //       const countryName = data.address?.country || '';
    //       setGeoState(state);
    //       setCountry(countryName);

    //       if (countryName !== 'India') {
    //         setGreeting('Hello');
    //       } else {
    //         // List of states where "Pranaam" is preferred
    //         const pranaamStates = [
    //           'Uttar Pradesh',
    //           'Bihar',
    //           'Madhya Pradesh',
    //           'Rajasthan',
    //           'Jharkhand',
    //           'Chhattisgarh'
    //         ];
    //         if (pranaamStates.some(s => state.includes(s))) {
    //           setGreeting('Pranaam');
    //         } else {
    //           setGreeting('Namaste');
    //         }
    //       }
    //     } catch (e) {
    //       setGeoState('');
    //       setCountry('');
    //       setGreeting('Namaste');
    //     }
    //   }, () => {
    //     setGeoState('');
    //     setCountry('');
    //     setGreeting('Namaste');
    //   });
    // }

  // Auto-detect user location and find nearest airport
  useEffect(() => {
    const findNearestAirportFromIPLocation = async () => {
      // Wait for userLocation to be set from IP address
      if (!userLocation || !userLocation.latitude || !userLocation.longitude) {
        return;
      }

      try {
        setLocationLoading(true);
        
        // Find nearest airports to user's IP-based location
        const nearestAirportsResult = await findNearestAirports(
          userLocation.latitude, 
          userLocation.longitude, 
          1, // Get 1 nearest airport
          50 // Within 50km
        );
        
        if (nearestAirportsResult.success && nearestAirportsResult.data.length > 0) {
          const nearest = nearestAirportsResult.data[0];
          
          // Format the airport data to match the expected structure
          const airportData = {
            value: nearest.iataCode,
            label: `${nearest.name} (${nearest.iataCode})`,
            cityName: nearest.municipality || nearest.name,
            iataCode: nearest.iataCode,
            name: nearest.name,
            municipality: nearest.municipality,
            geoCode: {
              latitude: nearest.latitude,
              longitude: nearest.longitude
            },
            distanceKm: nearest.distanceKm,
            isNearest: true
          };
          
          setNearestAirport(airportData);
          
          // Auto-fill the from field with the nearest airport
          setFromAirport(airportData);
          setFromInput(`${nearest.name} (${nearest.iataCode})`);
          
          console.log('📍 Auto-filled nearest airport from IP location:', airportData);
        }
      } catch (error) {
        console.log('📍 Airport search failed:', error.message);
        // Don't show error to user, just silently fail
      } finally {
        setLocationLoading(false);
      }
    };

    // Only run if we don't already have a from airport selected
    if (!fromAirport && userLocation?.latitude && userLocation?.longitude) {
      findNearestAirportFromIPLocation();
    }
  }, [userLocation, fromAirport]); // Run when userLocation changes

  useEffect(() => {
    // console.log('userLocation', userLocation);
  }, [userLocation]);

  useEffect(() => {
    if (!showDatePicker) return undefined;
    const handleClickOutside = (event) => {
      if (
        !event.target.closest('[data-date-picker]')
      ) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDatePicker]);

  useEffect(() => {
    let passengerText = `${numAdults} Adult${numAdults > 1 ? 's' : ''}`;
    if (numChildren > 0) {
      passengerText += ` ${numChildren} Child${numChildren === 1 ? '' : 'ren'}`;
    }
    if (numInfants > 0) {
      passengerText += ` ${numInfants} Infant${numInfants === 1 ? '' : 's'}`;
    }
    setPassengers(passengerText);
  }, [numAdults, numChildren, numInfants]);

  /** Campaign API product follows active Homepage tab; trains has no campaign product. */
  const homepageCampaignProduct = useMemo(() => {
    if (activeFormType === 'flight') {
      return PRODUCTS.FLIGHTS;
    }
    if (activeFormType === 'hotel') {
      return PRODUCTS.HOTELS;
    }
    return null;
  }, [activeFormType]);

  /** Campaign session synced from HomepageBannerCoordinator (single fetch for banner + popup). */
  const [homepageCampaignSession, setHomepageCampaignSession] = useState({
    campaigns: [],
    status: /** @type {'idle'} */ ('idle'),
    viewport: /** @type {'desktop'} */ ('desktop'),
    onNavigate: () => false,
  });

  const handleHomepageCampaignData = useCallback((session) => {
    setHomepageCampaignSession(session);
  }, []);

  const homepageCampaigns = homepageCampaignSession.campaigns;
  const homepageCampaignStatus = homepageCampaignSession.status;
  const homepageCampaignViewport = homepageCampaignSession.viewport;
  const homepageCampaignNavigate = homepageCampaignSession.onNavigate;

  // Flight / train / hotel AI guide — side icon height tracks greeting + input block
  useEffect(() => {
    const usesPairedLayout = activeFormType === 'flight' || activeFormType === 'train' || activeFormType === 'hotel';
    if (!usesPairedLayout) {
      setAiGuideContentHeight(null);
      return undefined;
    }
    const node = aiGuideContentRef.current;
    if (!node || typeof ResizeObserver === 'undefined') return undefined;

    const syncHeight = () => {
      setAiGuideContentHeight(node.getBoundingClientRect().height);
    };

    syncHeight();
    const observer = new ResizeObserver(syncHeight);
    observer.observe(node);
    window.addEventListener('resize', syncHeight);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', syncHeight);
    };
  }, [activeFormType, visibleText, inputWidth, gradientAnimationPlayed]);

  // Text is now constant - no typewriter effect needed
  // visibleText is already set to fullText in initial state


  // Fetch airports for 'From' field
  useEffect(() => {
    if (fromInput && fromInput.length >= 2) {
      setFromLoading(true);
      
      // Extract IATA code if user typed something like "BLR" or "Mumbai (BOM)"
      const iataMatch = fromInput.match(/\(([A-Z]{3})\)/);
      const searchTerm = iataMatch ? iataMatch[1] : fromInput;
      
      searchAirports(searchTerm)
        .then(async res => {
          // console.log('🔍 Homepage received search results:', res);
          // console.log('🔍 Homepage data length:', res.data?.length);
          const options = (res.data || []).map(a => {
            // console.log('🔍 Processing airport:', a);
            // All results should have valid IATA codes now
            if (a.iataCode && a.iataCode.length === 3) {
              // Create a better display label using the actual API response structure
              let cityInfo = a.address?.cityName ? ` - ${a.address.cityName}` : '';
              let countryInfo = a.address?.countryName ? `, ${a.address.countryName}` : '';
              
              // Special handling for nearest airports
              if (a.isNearestToCity) {
                cityInfo = ` - Nearest to ${a.originalCityName}`;
                countryInfo = ` (${a.distanceFromCity} km away)`;
              }
              
              return {
                label: `${a.name} (${a.iataCode})${cityInfo}${countryInfo}`,
                value: a.iataCode, // Always use the IATA code
                type: a.subType === 'AIRPORT' ? 'airport' : (a.mappedFromCity ? 'city-mapped' : 'city'),
                name: a.name,
                iataCode: a.iataCode,
                mappedFromCity: a.mappedFromCity || false,
                isNearestToCity: a.isNearestToCity || false,
                originalCityName: a.originalCityName,
                distanceFromCity: a.distanceFromCity,
                detailedName: a.detailedName,
                cityName: a.address?.cityName,
                countryName: a.address?.countryName,
                timeZoneOffset: a.timeZoneOffset,
                geoCode: a.geoCode,
                analytics: a.analytics,
                ...a
              };
            }
            return null;
          }).filter(option => option !== null);
          
          // console.log('🔍 Processed options:', options);
          
          if (options.length === 0) {
            // No airports found - set empty options to hide dropdown
            // console.log('❌ No valid options found');
            setFromOptions([]);
          } else {
            // Set options directly without nearby airports enhancement
          // console.log('✅ Setting options:', options.length);
          setFromOptions(options);
          }
        })
        .catch(error => {
          // console.error('Error searching airports:', error);
          setFromOptions([]);
        })
        .finally(() => setFromLoading(false));
    } else {
      setFromOptions([]);
    }
  }, [fromInput]);

  // Fetch airports for 'To' field
  useEffect(() => {
    if (toInput && toInput.length >= 2) {
      setToLoading(true);
      
      // Extract IATA code if user typed something like "BLR" or "Mumbai (BOM)"
      const iataMatch = toInput.match(/\(([A-Z]{3})\)/);
      const searchTerm = iataMatch ? iataMatch[1] : toInput;
      
      searchAirports(searchTerm)
        .then(async res => {
          const options = (res.data || []).map(a => {
            // All results should have valid IATA codes now
            if (a.iataCode && a.iataCode.length === 3) {
              // Create a better display label using the actual API response structure
              let cityInfo = a.address?.cityName ? ` - ${a.address.cityName}` : '';
              let countryInfo = a.address?.countryName ? `, ${a.address.countryName}` : '';
              
              // Special handling for nearest airports
              if (a.isNearestToCity) {
                cityInfo = ` - Nearest to ${a.originalCityName}`;
                countryInfo = ` (${a.distanceFromCity} km away)`;
              }
              
              return {
                label: `${a.name} (${a.iataCode})${cityInfo}${countryInfo}`,
                value: a.iataCode, // Always use the IATA code
                type: a.subType === 'AIRPORT' ? 'airport' : (a.mappedFromCity ? 'city-mapped' : 'city'),
                name: a.name,
                iataCode: a.iataCode,
                mappedFromCity: a.mappedFromCity || false,
                isNearestToCity: a.isNearestToCity || false,
                originalCityName: a.originalCityName,
                distanceFromCity: a.distanceFromCity,
                detailedName: a.detailedName,
                cityName: a.address?.cityName,
                countryName: a.address?.countryName,
                timeZoneOffset: a.timeZoneOffset,
                geoCode: a.geoCode,
                analytics: a.analytics,
                ...a
              };
            }
            return null;
          }).filter(option => option !== null);
          
          if (options.length === 0) {
            // No airports found - set empty options to hide dropdown
            setToOptions([]);
          } else {
            // Set options directly without nearby airports enhancement
            setToOptions(options);
          }
        })
        .catch(error => {
          // console.error('Error searching airports:', error);
          setToOptions([]);
        })
        .finally(() => setToLoading(false));
    } else {
      setToOptions([]);
    }
  }, [toInput]);

  // Fetch calendar prices when airports are selected
  useEffect(() => {
    const fetchCalendarPrices = async () => {
      if (!fromAirport?.value || !toAirport?.value) {
        setCalendarPrices({});
        return;
      }

      setPriceLoading(true);
      try {
        // Generate dates for the next 3 months
        const today = new Date();
        const prices = {};
        
        // Fetch prices for next 90 days
        for (let i = 0; i < 90; i++) {
          const date = new Date(today);
          date.setDate(today.getDate() + i);
          const dateKey = date.toISOString().split('T')[0];
          
          // Simulate price data (replace with actual API call)
          const basePrice = 5000 + Math.random() * 10000;
          const dayOfWeek = date.getDay();
          
          // Higher prices on weekends
          const weekendMultiplier = (dayOfWeek === 0 || dayOfWeek === 6) ? 1.3 : 1;
          
          // Random price variation
          const variation = 0.8 + Math.random() * 0.4; // 80% to 120% of base
          
          prices[dateKey] = Math.round(basePrice * weekendMultiplier * variation);
        }
        
        setCalendarPrices(prices);
      } catch (error) {
        console.error('Error fetching calendar prices:', error);
      } finally {
        setPriceLoading(false);
      }
    };

    fetchCalendarPrices();
  }, [fromAirport?.value, toAirport?.value]);

  const { updateSearchParams } = useSearchContext();

  // Custom day renderer for calendar with prices
  const renderDayContents = (day, date) => {
    const dateKey = date.toISOString().split('T')[0];
    const price = calendarPrices[dateKey];
    
    if (!price) {
      return <span>{day}</span>;
    }

    // Determine price color based on value
    const getPriceColor = (price) => {
      // Get all prices to determine relative pricing
      const allPrices = Object.values(calendarPrices);
      if (allPrices.length === 0) return '#666';
      
      const minPrice = Math.min(...allPrices);
      const maxPrice = Math.max(...allPrices);
      const priceRange = maxPrice - minPrice;
      
      // Define thresholds: bottom 33% = green, middle 33% = yellow, top 33% = red
      const lowThreshold = minPrice + (priceRange * 0.33);
      const highThreshold = minPrice + (priceRange * 0.66);
      
      if (price <= lowThreshold) {
        return '#4CAF50'; // Green for good prices
      } else if (price <= highThreshold) {
        return '#FF9800'; // Orange/Yellow for medium prices
      } else {
        return '#F44336'; // Red for high prices
      }
    };

    const priceColor = getPriceColor(price);

    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        fontSize: '9px',
        lineHeight: '1.1',
        padding: '1px'
      }}>
        <span style={{ fontWeight: '500', fontSize: '9px' }}>{day}</span>
        <span style={{ 
          fontSize: '7px', 
          color: priceColor,
          fontWeight: '600',
          marginTop: '1px'
        }}>
          ₹{(price/1000).toFixed(0)}k
        </span>
      </div>
    );
  };

  const getPassengerCounts = () => {
    return { adults: numAdults, children: numChildren, infants: numInfants };
  };

  // Search handler
  const handleSearch = () => {
    const { adults, children, infants } = getPassengerCounts();
    
    // Format dates to YYYY-MM-DD format (using local timezone)
    const formatDate = (date) => {
      if (!date) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = tripType === 'oneway' ? '' : formatDate(endDate);
    
    // Update global search context
    updateSearchParams({
      from: fromAirport?.value || '',
      to: toAirport?.value || '',
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      adults: adults,
      children: children,
      infants: infants,
      travelClass: travelClass,
      tripType: tripType,
    });
    
    const params = new URLSearchParams({
      from: fromAirport?.value || '',
      to: toAirport?.value || '',
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      adults: adults.toString(),
      children: children.toString(),
      infants: infants.toString(),
      class: travelClass,
      tripType: tripType,
      userLocation: btoa(JSON.stringify(userLocation))
    });
    navigate(`/flight?${params.toString()}`);
  };

  // Helper function to navigate to guide page — fetches full JSON on-demand
  const navigateToGuide = useCallback(async (category, placeData) => {
    const name = placeData?.hero?.title || placeData?.place?.name || placeData?.destination || '';
    const slug = slugify(name) || 'destination';

    try {
      const res = await fetch(`${BACKEND_URL}/api/destination/guide/${encodeURIComponent(name)}`);
      const json = await res.json();
      if (json.success && json.data) {
        navigate(`/destinations/${slug}`, {
          state: { placeData: json.data, category }
        });
        return;
      }
    } catch (_) { /* fallback to lightweight data */ }

    navigate(`/destinations/${slug}`, {
      state: { placeData, category }
    });
  }, [navigate]);

  const openDestinationGuide = useCallback((destination) => {
    navigateToGuide(destination.category, destination.output_json);
  }, [navigateToGuide]);

  // Helper function to handle popular place card clicks
  const handlePopularPlaceClick = (category, placeData) => {
    if (!category) {
      // If no category, navigate to guide page
      navigateToGuide(category, placeData);
      return;
    }

    // Map category names to section IDs
    const categoryLower = category.toLowerCase();
    let sectionId = null;

    // Match by DB-driven section titles (from sectionMeta) or legacy names
    const sectionIdMap = [
      { domId: 'nearby-treasures-section', metaId: 1, legacy: ['nearby treasures', 'trending trips', 'trending'] },
      { domId: 'global-hotspots-section', metaId: 2, legacy: ['global hotspots', 'bucket list'] },
      { domId: 'weekend-collection-section', metaId: 3, legacy: ['weekend collection', 'weekend getaway', 'tropical paradise'] },
      { domId: 'visa-free-wonders-section', metaId: 4, legacy: ['visa-free', 'visa free', 'into the wild'] },
      { domId: 'seasons-finest-section', metaId: 5, legacy: ['season', 'seasonal', 'hidden gems', 'offbeat'] },
    ];

    for (const entry of sectionIdMap) {
      const dbTitle = (sectionMeta[entry.metaId]?.title || '').toLowerCase();
      if ((dbTitle && categoryLower.includes(dbTitle)) || 
          (dbTitle && dbTitle.includes(categoryLower)) ||
          entry.legacy.some(l => categoryLower.includes(l))) {
        sectionId = entry.domId;
        break;
      }
    }

    // If we found a matching section, scroll to it
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    // If no matching section found, navigate to guide page
    navigateToGuide(category, placeData);
  };

  return (
    <>
    <PageHelmet
      fullTitle={SEO_DEFAULTS.homepageFullTitle}
      description={SEO_DEFAULTS.defaultDescription}
      path="/"
      jsonLd={buildHomepageSchema({
        pageTitle: SEO_DEFAULTS.homepageFullTitle,
        description: SEO_DEFAULTS.defaultDescription,
      })}
    />
    <Box
      className="homepage-root"
      data-homepage-ready="true"
      sx={{
      minHeight: '100dvh', 
      background: '#F5F5F7',
      display: 'flex', 
      flexDirection: 'column',
      color: '#000', 
      position: 'relative',
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
      '& > *': {
        maxWidth: '100%',
      },
      // Responsive scaling for different screen sizes
      fontSize: {
        xs: '14px',    // Mobile: base 14px
        sm: '14px',    // Small tablets: match mobile
        md: '16px',    // Medium screens: 16px
        lg: '17px',    // Large screens: 17px
        xl: '18px'     // Extra large: 18px
      },
      // Ensure proper scaling on very large screens
      '@media (min-width: 1920px)': {
        fontSize: '20px',
        '& *': {
          fontSize: 'inherit'
        }
      },
      // Ensure proper scaling on very small screens
      '@media (max-width: 480px)': {
        fontSize: '13px'
      },
    }}
    >
      
      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100dvh',
          boxSizing: 'border-box',
          p: 0,
          pb: { xs: '130px', sm: '130px', md: 0 },
          width: '100%',
          maxWidth: '100%',
          pr: chatbotOpen && showHomepageChatbotSidebar ? { xs: 0, sm: 0, md: '340px', lg: '360px', xl: '380px' } : 0,
          transition: 'padding-right 0.3s',
          position: 'relative',
          zIndex: 2,
          // Ensure proper scaling on all screen sizes
          '& > *': {
            width: '100%',
            maxWidth: '100%'
          },
          // Removed transform scaling - using proportional padding instead for better control
          // Transform scaling was causing layout issues on large screens
        }}
      >
        {/* Header - Common Header Component */}
        {/* Desktop/Tablet header — hidden on mobile.
           display:contents on sm+ so the sticky header's containing block is the
           tall flex parent, giving position:sticky enough room to actually stick. */}
        <Box
          className="homepage-yovo-header-host"
          sx={{ display: { xs: 'none', sm: 'none', md: 'contents' } }}
        >
          <YovoTripHeader />
        </Box>
        {/* Mobile header — replaces YovoTripHeader + FlightOneWayRoundTripSearchBar on mobile */}
        <MobileHeader
          activeFormType={activeFormType}
          onFormTypeChange={switchToForm}
          onGlobeClick={() => setRegionalSettingsOpen(true)}
        />

        <Box
          component="main"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            width: '100%',
            minWidth: 0,
            '& > *': {
              width: '100%',
              maxWidth: '100%',
            },
          }}
        >
        {/* Reddish-Brown Hero Banner */}
        <FlightOneWayRoundTripSearchBar 
          tripType={flightFormState.tripType}
          multiCitySegments={flightFormState.multiCitySegments}
          icon={activeFormType}
        />

        {/* Main Background Section */}
        <Box
          id="yovo-homepage-main-card"
          sx={{
            // Figma 390px frame → 350px content (20px gutters each side)
            width: { xs: L.formCardWidth, sm: L.formCardWidth, md: '100%' },
            mx: { xs: 'auto', sm: 'auto', md: 0 },
            // Mobile: match card bg so no visible strip above the card
            bgcolor: { xs: 'transparent', sm: 'transparent', md: '#F5F5F7' },
            // Desktop keeps a card height. On mobile the card hugs the form so a missing campaign leaves no gap under Let's Go.
            minHeight: { xs: 0, sm: 0, md: activeFormType === 'hotel' ? '50px' : '400px' },
            flex: { xs: '0 0 auto', sm: '0 0 auto', md: 1 },
            position: 'relative',
            /* Above red header bg (z-index 1), below tab pills (z-index 3) */
            zIndex: { xs: 2, sm: 2, md: 'auto' },
            /* Red tail depth = headerRedTail; pt keeps trip-type below tabs */
            mt: { xs: L.formCardPullUp, sm: L.formCardPullUp, md: '-28px' },
            pt: { xs: L.formCardTopClearance, sm: L.formCardTopClearance, md: '0px' },
            // Rounded top corners — grey card floats over red on both sides
            borderRadius: { xs: `${L.formCardRadius} ${L.formCardRadius} 0 0`, sm: `${L.formCardRadius} ${L.formCardRadius} 0 0`, md: 0 },
            overflow: 'visible',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              // background: 'linear-gradient(135deg, var(--Neutrals-grey-200, #E8E9ED) 0%, var(--Neutrals-grey-200, #E8E9ED) 100%)',
              zIndex: 0
            }
          }}
        >
          {/*
            Homepage campaign layout (flex order):
            Mobile:  Form → Homepage Banner
            Desktop: Form → AI Initiative → Homepage Banner
          */}
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: 0 }}>
            {/* Search widget — overlaps red hero banner on desktop */}
            <Box sx={{ order: { xs: 1, md: 1 }, width: '100%', minWidth: 0 }}>
              {activeFormType === 'flight' ? (
                <FlightForm
                  onStateChange={handleFlightFormStateChange}
                  onAuthRequired={handleAuthRequired}
                />
              ) : activeFormType === 'train' ? (
                <TrainForm
                  onStateChange={handleTrainFormStateChange}
                  onAuthRequired={handleAuthRequired}
                />
              ) : (
                <HotelForm
                  onStateChange={handleHotelFormStateChange}
                  onAuthRequired={handleAuthRequired}
                />
              )}
            </Box>

            {/* AI Initiative — desktop only */}
            <Box sx={{
              order: { xs: 0, md: 2 },
              width: '100%',
              display: { xs: 'none', sm: 'none', md: 'flex' },
              flexDirection: 'column',
              alignItems: 'center',
              mt: {
                xs: 2,
                md: activeFormType === 'flight' && flightFormState.tripType === 'multicity' ? '104px' : '54px',
              },
              mb: {
                xs: 1,
                md: activeFormType === 'hotel'
                  ? '54px'
                  : activeFormType === 'flight' && flightFormState.tripType === 'multicity' ? 6 : 2,
              },
              paddingLeft: {
                xs: '16px',
                sm: '16px',
                md: 'clamp(20px, 1.25vw, 40px)',
                lg: 'clamp(24px, 1.25vw, 48px)',
              },
              paddingRight: {
                xs: '16px',
                sm: '16px',
                md: 'clamp(20px, 1.25vw, 40px)',
                lg: 'clamp(24px, 1.25vw, 48px)',
              },
            }}>
            <Typography
              component="h1"
              sx={{
                margin: 0,
                fontWeight: 500,
                fontSize: { 
                  xs: '0.8rem',
                  sm: '0.8rem',
                  md: '16px',
                  lg: '1.1rem',
                  xl: '1.2rem'
                },
                color: '#000',
                textAlign: 'center',
                letterSpacing: '0.3px',
                minHeight: '1.5em',
                opacity: 1,
                lineHeight: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.5,
                width: '100%',
              }}
            >
              <AutoAwesome sx={{ fontSize: 'inherit', color: '#000', flexShrink: 0 }} />
              {visibleText}
            </Typography>

            <Box
              sx={{
                width: '100%',
                justifyContent: 'center',
              }}
              className="homepage-ai-travel-guide-row homepage-ai-travel-guide-row--paired"
            >
              <Box
                className="homepage-ai-travel-guide-content"
                ref={aiGuideContentRef}
              >
                {/* Search Input */}
                <Box 
                className={gradientAnimationPlayed ? 'gradient-border-animate' : ''}
                sx={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  background: '#fff',
                  borderRadius: '25px',
                  border: '2px solid transparent',
                  backgroundImage: 'linear-gradient(white, white), linear-gradient(-4deg, rgba(187, 0, 255, 0.44) 0%, rgba(0, 178, 255, 0.44) 30%, rgba(108, 39, 255, 0.44) 65%, rgba(255, 0, 0, 0.44) 100%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'content-box, border-box',
                  overflow: 'hidden',
                  width: { xs: '100%', md: `${inputWidth}px` },
                  maxWidth: '100%',
                }}>
                  <input
                    type="text"
                    placeholder="If you could teleport right now... where's your dream stop?"
                    value={chatbotInputText}
                    onChange={(e) => setChatbotInputText(e.target.value)}
                    onKeyPress={handleChatbotKeyPress}
                    autoComplete="off"
                    style={{
                      flex: 1,
                      padding: '12px 20px',
                      border: 'none',
                      outline: 'none',
                      fontFamily: HOST_GROTESK_FAMILY,
                      fontWeight:'400',
                      fontSize: '16px',
                      color: '#333',
                      background: 'transparent',
                      opacity: 1
                    }}
                  />
                  <Box 
                    onClick={handleChatbotSend}
                    sx={{
                      width: '40px',
                      height: '40px',
                      background: '#000',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '4px',
                      cursor: 'pointer',
                      opacity: 1,
                      '&:hover': {
                        background: '#333'
                      }
                    }}>
                    <Box 
                      component="img"
                      src={playicon}
                      alt="Send"
                      sx={{
                        width: '24px',
                        height: '24px',
                        objectFit: 'contain'
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              {shouldRenderHomepageMascot(isMdUp) && (activeFormType === 'flight' || activeFormType === 'train' || activeFormType === 'hotel') && (
                <Box
                  className={
                    activeFormType === 'flight'
                      ? 'homepage-ai-travel-guide-side-visual homepage-ai-travel-guide-mascot'
                      : 'homepage-ai-travel-guide-side-visual'
                  }
                  aria-hidden="true"
                  sx={{
                    ...(aiGuideContentHeight
                      ? { height: `${aiGuideContentHeight}px`, opacity: 1 }
                      : { height: 0, opacity: 0, overflow: 'hidden' }),
                  }}
                >
                  <img
                    src={
                      activeFormType === 'train'
                        ? train_homepage_icon
                        : activeFormType === 'hotel'
                          ? hotel_icon
                          : woman_icon_without_bg
                    }
                    alt=""
                  />
                </Box>
              )}
            </Box>
          </Box>

            {/* Homepage Banner — campaign carousel (Banner Web / Mobile) */}
            <Box sx={{ order: { xs: 2, md: 3 }, width: '100%', minWidth: 0 }}>
              <Suspense fallback={null}>
                <HomepageBannerCoordinator
                  product={homepageCampaignProduct}
                  onCampaignData={handleHomepageCampaignData}
                />
              </Suspense>
            </Box>
          </Box>
        </Box>

        {/* Travel Gallery Section */}
        <Box sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          mt: { xs: 2, sm: 2, md: 0 },
          mb: 1,
          // Match red background outer wrapper padding
          paddingLeft: { 
            xs: '16px', 
            sm: '16px', 
            md: 'clamp(20px, 1.25vw, 40px)',
            lg: 'clamp(24px, 1.25vw, 48px)'
          },
          paddingRight: { 
            xs: '16px', 
            sm: '16px', 
            md: 'clamp(20px, 1.25vw, 40px)',
            lg: 'clamp(24px, 1.25vw, 48px)'
          }
        }}>
          <Box sx={{
            width: '100%',
            maxWidth: {
              xs: '100%',     // Mobile: full width
              sm: '100%',     // Small: full width
              md: '1200px',   // Medium: 1200px - matches red bg
              lg: '1400px',   // Large: 1400px - matches red bg
              xl: '1600px'    // Extra large: 1600px - matches red bg
            },
            position: 'relative',
            background: 'none',
            mx: 'auto', // Center to match red bg alignment
            pt: 0, // No padding top to maintain equal spacing with AI Travel Guide section
            pb: { xs: 2, sm: 2, md: 4 } // Padding bottom only
          }}>
            
            {/* Travel Gallery Layout */}
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '16px', sm: '16px', md: '24px', lg: '28px', xl: '32px' }
            }}>
              {/* Top Row - Featured + Grid */}
              <Box sx={{
                display: 'flex',
                gap: '20px',
                flexDirection: { xs: 'column', lg: 'row' },
                alignItems: 'stretch'
              }}>
                {/* Featured Destination — no reserved box until a place exists, so hotel search does not sit above a blank gap. */}
                {popularPlacesFromSections && popularPlacesFromSections.length > 0 ? (
                <Box sx={{
                  width: { xs: '100%', lg: '652px' },
                  maxWidth: { xs: '100%', lg: '652px' },
                  flexShrink: 0,
                  aspectRatio: '16/9',
                  position: 'relative',
                  minHeight: 0
                }}>
                    <Box
                      onClick={() => {
                        const place = popularPlacesFromSections[0];
                        handlePopularPlaceClick(place.category, place.output_json);
                      }}
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        height: '100%',
                        borderRadius: 2,
                        overflow: 'hidden',
                        cursor: 'pointer',
                        '&:hover': {
                          '& img': {
                            transform: 'scale(1.1)',
                            transition: 'transform 0.3s ease'
                          }
                        }
                      }}
                    >
                      <YovoImage
                        src={destinationImageProps(popularPlacesFromSections[0]).src}
                        alt={destinationImageProps(popularPlacesFromSections[0]).alt}
                        width={652}
                        height={367}
                        sizes="(max-width: 900px) 100vw, 652px"
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          objectPosition: 'center',
                          transition: 'transform 0.3s ease',
                          transform: 'scale(1)',
                          zIndex: 0
                        }}
                      />
                      {/* Badge */}
                      <Box sx={{
                        position: 'absolute',
                        top: 12,
                        left: 12,
                        background: 'rgba(255, 255, 255, 0.72)',
                        borderRadius: 1,
                        px: 1,
                        py: 0.5,
                        zIndex: 2,
                        maxWidth: 'calc(100% - 24px)'
                      }}>
                        <Typography sx={{
                          color: '#2B2B2B',
                          fontFamily: `${HOST_GROTESK_FAMILY}, -apple-system, Roboto, Helvetica, sans-serif`,
                          fontSize: '12px',
                          fontWeight: 700,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}>
                          {popularPlacesFromSections[0].category || 'Trending Trips Near You'}
                        </Typography>
                      </Box>

                      {/* Overlay */}
                      <Box sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.56) 100%)',
                        p: 2,
                        zIndex: 1
                      }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          <Typography sx={{
                            color: '#FFF',
                            fontFamily: `${HOST_GROTESK_FAMILY}, -apple-system, Roboto, Helvetica, sans-serif`,
                            fontSize: { xs: '20px', sm: '20px', md: '23px' },
                            fontWeight: 700
                          }}>
                            {popularPlacesFromSections[0].output_json?.hero?.title || popularPlacesFromSections[0].destination || popularPlacesFromSections[0].title || popularPlacesFromSections[0].name || 'Destination'}
                          </Typography>
                          <Typography sx={{
                            color: '#FBFBFB',
                            fontFamily: `${HOST_GROTESK_FAMILY}, -apple-system, Roboto, Helvetica, sans-serif`,
                            fontSize: '12px',
                            fontWeight: 400
                          }}>
                            Flights • Hotels • Resorts
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                </Box>
                ) : null}

                {/* Grid of smaller destinations */}
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '20px',
                  flex: 1,
                  minWidth: 0, // Allow flex item to shrink below content size
                  width: { xs: '100%', lg: 'auto' }, // Full width on mobile, auto on desktop
                  minHeight: 0 // Allow flex item to shrink
                }}>
                  {/* First row of grid */}
                  <Box sx={{
                    display: 'flex',
                    gap: '20px',
                    flexDirection: { xs: 'column', sm: 'column', md: 'row' },
                    flex: 1, // Take equal space with second row
                    minHeight: 0
                  }}>
                    {popularPlacesFromSections && popularPlacesFromSections.length > 1 ? popularPlacesFromSections.slice(1, 3).map((place, index) => (
                      <Box
                        key={index + 1}
                      onClick={() => {
                        handlePopularPlaceClick(place.category, place.output_json);
                      }}
                      sx={{
                          flex: 1,
                          width: { xs: '100%', sm: '100%', md: 'calc(50% - 10px)', lg: '314px' },
                          aspectRatio: '4/3', // Wider aspect ratio (less tall) for consistent shape
                          minHeight: 0,
                          borderRadius: 2,
                        position: 'relative',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        '&:hover': {
                          '& img': {
                            transform: 'scale(1.1)',
                            transition: 'transform 0.3s ease'
                          }
                        }
                      }}
                    >
                      <YovoImage
                        src={destinationImageProps(place).src}
                        alt={destinationImageProps(place).alt}
                        width={314}
                        height={236}
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          objectPosition: 'center',
                          transition: 'transform 0.3s ease',
                          transform: 'scale(1)',
                          zIndex: 0
                        }}
                      />
                        {/* Badge */}
                      <Box sx={{
                        position: 'absolute',
                          top: 12,
                          left: 12,
                          background: 'rgba(255, 255, 255, 0.72)',
                          borderRadius: 1,
                          px: 1,
                          py: 0.5,
                          zIndex: 2,
                          maxWidth: 'calc(100% - 24px)'
                        }}>
                          <Typography sx={{
                            color: '#2B2B2B',
                            fontFamily: `${HOST_GROTESK_FAMILY}, -apple-system, Roboto, Helvetica, sans-serif`,
                            fontSize: '12px',
                            fontWeight: 700,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}>
                            {place.category || 'Travel Destination'}
                          </Typography>
                        </Box>

                        {/* Overlay */}
                        <Box sx={{
                          position: 'absolute',
                          bottom: 0,
                        left: 0,
                        right: 0,
                          background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.56) 100%)',
                          p: 2,
                          zIndex: 1
                        }}>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <Typography sx={{
                              color: '#FFF',
                              fontFamily: `${HOST_GROTESK_FAMILY}, -apple-system, Roboto, Helvetica, sans-serif`,
                              fontSize: { xs: '16px', sm: '16px', md: '20px' },
                              fontWeight: 700
                            }}>
                              {place.output_json?.hero?.title || place.destination || place.title || place.name || 'Destination'}
                            </Typography>
                            <Typography sx={{
                              color: '#FBFBFB',
                              fontFamily: `${HOST_GROTESK_FAMILY}, -apple-system, Roboto, Helvetica, sans-serif`,
                              fontSize: '12px',
                              fontWeight: 400
                            }}>
                              Flights • Hotels • Resorts
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    )) : Array.from({ length: 2 }, (_, index) => (
                      <Box
                        key={index}
                        sx={{
                          flex: 1,
                          width: { xs: '100%', sm: '100%', md: 'calc(50% - 10px)', lg: '314px' },
                          aspectRatio: '4/3', // Wider aspect ratio (less tall) for consistent shape
                          minHeight: 0,
                          background: '#F5F5F7',
                          borderRadius: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#666'
                        }}
                      >
                        <Typography sx={{ fontSize: '1rem', fontWeight: 500 }}>
                          Loading destinations...
                        </Typography>
                      </Box>
                    ))}
                  </Box>

                  {/* Second row of grid */}
                  <Box sx={{
                    display: 'flex',
                    gap: '20px',
                    flexDirection: { xs: 'column', sm: 'column', md: 'row' },
                    flex: 1, // Take equal space with first row
                    minHeight: 0
                  }}>
                    {popularPlacesFromSections && popularPlacesFromSections.length > 3 ? popularPlacesFromSections.slice(3, 5).map((place, index) => (
                      <Box
                        key={index + 3}
                        onClick={() => {
                          handlePopularPlaceClick(place.category, place.output_json);
                        }}
                        sx={{
                          flex: 1,
                          width: { xs: '100%', sm: '100%', md: 'calc(50% - 10px)', lg: '314px' },
                          aspectRatio: '4/3', // Wider aspect ratio (less tall) for consistent shape
                          minHeight: 0,
                          borderRadius: 2,
                          position: 'relative',
                          overflow: 'hidden',
                          cursor: 'pointer',
                          '&:hover': {
                            '& img': {
                              transform: 'scale(1.1)',
                              transition: 'transform 0.3s ease'
                            }
                          }
                        }}
                      >
                      <YovoImage
                        src={destinationImageProps(place).src}
                        alt={destinationImageProps(place).alt}
                        width={314}
                        height={236}
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          objectPosition: 'center',
                          transition: 'transform 0.3s ease',
                          transform: 'scale(1)',
                          zIndex: 0
                        }}
                      />
                        {/* Badge */}
                      <Box sx={{
                        position: 'absolute',
                          top: 12,
                          left: 12,
                          background: 'rgba(255, 255, 255, 0.72)',
                          borderRadius: 1,
                          px: 1,
                          py: 0.5,
                          zIndex: 2,
                          maxWidth: 'calc(100% - 24px)'
                        }}>
                          <Typography sx={{
                            color: '#2B2B2B',
                            fontFamily: `${HOST_GROTESK_FAMILY}, -apple-system, Roboto, Helvetica, sans-serif`,
                            fontSize: '12px',
                            fontWeight: 700,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}>
                            {place.category || 'Travel Destination'}
                          </Typography>
                        </Box>

                        {/* Overlay */}
                        <Box sx={{
                          position: 'absolute',
                          bottom: 0,
                        left: 0,
                        right: 0,
                          background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.56) 100%)',
                          p: 2,
                          zIndex: 1
                        }}>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <Typography sx={{
                              color: '#FFF',
                              fontFamily: `${HOST_GROTESK_FAMILY}, -apple-system, Roboto, Helvetica, sans-serif`,
                              fontSize: { xs: '16px', sm: '16px', md: '20px' },
                              fontWeight: 700
                            }}>
                            {place.output_json?.hero?.title || place.destination || place.title || place.name || 'Destination'}
                          </Typography>
                            <Typography sx={{
                              color: '#FBFBFB',
                              fontFamily: `${HOST_GROTESK_FAMILY}, -apple-system, Roboto, Helvetica, sans-serif`,
                              fontSize: '12px',
                              fontWeight: 400
                            }}>
                              Flights • Hotels • Resorts
                          </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                        </Box>
                      </Box>
                    </Box>
                      </Box>
                    )) : Array.from({ length: 2 }, (_, index) => (
                  <Box
                    key={index}
                    sx={{
                          flex: 1,
                          width: { xs: '100%', sm: '100%', md: 'calc(50% - 10px)', lg: '314px' },
                          height: '100%', // Fill the row height
                          minHeight: 0,
                      background: '#F5F5F7',
                          borderRadius: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#666'
                        }}
                      >
                        <Typography sx={{ fontSize: '1rem', fontWeight: 500 }}>
                          Loading destinations...
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>

            </Box>
          </Box>
        </Box>

        {/* Trending Trips Around You Section */}
        <Box 
          id="nearby-treasures-section"
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            mt: 2,
            mb: 2,
            // Match red background outer wrapper padding
            paddingLeft: { 
              xs: '16px', 
              sm: '16px', 
              md: 'clamp(20px, 1.25vw, 40px)',
              lg: 'clamp(24px, 1.25vw, 48px)'
            },
            paddingRight: { 
              xs: '16px', 
              sm: '16px', 
              md: 'clamp(20px, 1.25vw, 40px)',
              lg: 'clamp(24px, 1.25vw, 48px)'
            }
          }}>
          <Box sx={{
            width: '100%',
            maxWidth: {
              xs: '100%',     // Mobile: full width
              sm: '100%',     // Small: full width
              md: '1200px',   // Medium: 1200px - matches red bg
              lg: '1400px',   // Large: 1400px - matches red bg
              xl: '1600px'    // Extra large: 1600px - matches red bg
            },
            display: 'flex',
            mx: 'auto', // Center to match red bg alignment
            py: { 
              xs: '16px',    // Mobile: smaller vertical padding
              sm: '16px',    // Small: match mobile
              md: '24px',    // Medium: standard vertical padding
              lg: '28px',    // Large: larger vertical padding
              xl: '32px'     // Extra large: largest vertical padding
            },
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: '12px', sm: '12px', md: '16px', lg: '18px', xl: '20px' },
            alignSelf: 'stretch',
            background: '#F5F5F7'
    }}>
      <style>{datePickerStyles}</style>
      {/* Header */}
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '12px',
              alignSelf: 'stretch',
              borderRadius: '12px'
            }}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: { xs: '16px', sm: '16px', md: '20px', lg: '28px', xl: '32px' }
              }}>
                <Box component="img" src={trending_trips_around_you_icon} sx={{
                  width: { xs: '40px', sm: '40px', md: '64px' },
                  height: { xs: '40px', sm: '40px', md: '64px' }
                }} />
                <Box>
                  <Typography sx={{
                    color: 'var(--Neutrals-base-black, #20202A);',
                    fontFamily: HOST_GROTESK_FAMILY,
                    fontSize: { xs: '20px', sm: '20px', md: '28px' },
                    fontWeight: 700,
                    lineHeight: { xs: '28px', sm: '28px', md: '36px' }
                  }}>
                    {sectionMeta[1]?.title || 'Explore What\'s Trending'}
                  </Typography>
                  <Typography sx={{
                    width: '100%',
                    maxWidth: '550px',
                    color: '#6C6C6C',
                    fontFamily: HOST_GROTESK_FAMILY,
                    fontSize: '12px',
                    fontWeight: 400,
                    opacity: 0.75
                  }}>
                    {sectionMeta[1]?.subtitle || 'Discover the world\'s most popular destinations.'}
                  </Typography>
                </Box>
              </Box>
              
              {/* Navigation Arrows for Destinations */}
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <Box 
                  onClick={() => {
                    const newIndex = Math.max(0, currentDestinationIndex - 4);
                    if (newIndex !== currentDestinationIndex) {
                      setCurrentDestinationIndex(newIndex);
                      setCurrentImageIndex(0); // Reset image index when changing destination
                    }
                  }}
                  sx={{
                    width: '40px',
                    height: '40px',
                    background: currentDestinationIndex > 0 ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.5)',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: currentDestinationIndex > 0 ? 'pointer' : 'not-allowed',
                    transition: 'all 0.3s ease',
                    '&:hover': currentDestinationIndex > 0 ? {
                      background: 'rgba(255,255,255,1)',
                      transform: 'scale(1.1)'
                    } : {}
                  }}
                >
                  <ArrowBackIcon sx={{ color: '#333', fontSize: '18px' }} />
                </Box>
                <Box 
                  onClick={() => {
                    const newIndex = Math.min(trending_trips.length - 1, currentDestinationIndex + 4);
                    if (newIndex !== currentDestinationIndex && newIndex < trending_trips.length) {
                      setCurrentDestinationIndex(newIndex);
                      setCurrentImageIndex(0); // Reset image index when changing destination
                    }
                  }}
                  sx={{
                    width: '40px',
                    height: '40px',
                    background: currentDestinationIndex < trending_trips.length - 1 ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.5)',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: currentDestinationIndex < trending_trips.length - 1 ? 'pointer' : 'not-allowed',
                    transition: 'all 0.3s ease',
                    '&:hover': currentDestinationIndex < trending_trips.length - 1 ? {
                      background: 'rgba(255,255,255,1)',
                      transform: 'scale(1.1)'
                    } : {}
                  }}
                >
                  {/* <Typography sx={{ color: 'white', fontSize: '18px', fontWeight: 600 }}>›</Typography> */}
                  <ArrowForwardIcon sx={{ color: '#333', fontSize: '18px' }} />
                  
                </Box>
              </Box>
            </Box>

            {/* Main Content */}
            {trending_trips && trending_trips.length > 0 && (
              <Box sx={{
                display: 'flex',
                gap: { xs: 2, sm: 2, md: 4 },
                flexDirection: { xs: 'column', lg: 'row' },
                width: '100%',
                alignItems: { xs: 'center', lg: 'stretch' } // Center on small screens, stretch on large to match heights
              }}>
                {/* Featured Destination Card */}
                <Box 
                  onClick={() => {
                    // console.log('Navigating to IstanbulGuide with data:', trending_trips[currentDestinationIndex].output_json);
                    navigateToGuide(trending_trips[currentDestinationIndex].category,trending_trips[currentDestinationIndex].output_json);
                  }}
                  sx={{
                    flex: { xs: '0 0 auto', lg: '0 0 50%' }, // Don't stretch on small screens
                    position: 'relative',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    width: '100%',
                    maxWidth: { 
                      xs: '460px', 
                      sm: '460px', 
                      md: '460px', 
                      lg: '460px',
                      xl: '460px'
                    }, // Responsive max width across screen sizes
                    aspectRatio: '1.029', // Maintain aspect ratio on all screen sizes
                    maxHeight: { lg: '100%' }, // Don't exceed right side height on large screens
                    cursor: 'pointer',
                    transition: 'background-size 0.3s ease',
                    alignSelf: { xs: 'center', lg: 'stretch' }, // Center on small screens, stretch on large
                    '&:hover': {
                      backgroundSize: '110%',
                    }
                  }}
                >
                  {/* Background Images with Crossfade */}
                  {previousImageUrl && (
                    <Box 
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `url(${previousImageUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        transition: 'opacity 0.5s ease-in-out',
                        opacity: 0, // Fades out
                        zIndex: 1,
                        pointerEvents: 'none'
                      }} 
                    />
                  )}
                  <Box 
                    key={`image-${currentImageIndex}`}
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: `url(${currentImage})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      transition: 'opacity 0.5s ease-in-out',
                      opacity: 1,
                      zIndex: 2,
                      pointerEvents: 'none'
                    }} 
                  />
                  
                  {/* Content - Top Left */}
                  <Box sx={{
                    position: 'absolute',
                    top: 20,
                    left: 20,
                    zIndex: 2,
                    color: 'white'
                  }}>
                    <Typography sx={{ 
                      fontSize: '1.8rem', 
                      fontWeight: 700, 
                      mb: 1,
                      textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                    }}>
                      {trending_trips[currentDestinationIndex].output_json?.hero?.title || 'Destination'}
                    </Typography>
                    <Typography sx={{ 
                      fontSize: '1rem', 
                      opacity: 0.9,
                      textShadow: '0 1px 2px rgba(0,0,0,0.5)',
                      mb: 2
                    }}>
                      {trending_trips[currentDestinationIndex].output_json?.place?.country || 'International'}
                    </Typography>
                  </Box>

                  {/* Navigation Arrows for Images - Bottom */}
                  <Box sx={{
                    position: 'absolute',
                    bottom: 20,
                    left: 20,
                    right: 20,
                    display: 'flex',
                    justifyContent: 'space-between',
                    zIndex: 2
                  }}>
                    <Box 
                      onClick={(e) => {
                        e.stopPropagation();
                        if (currentImageIndex > 0) {
                          setCurrentImageIndex(currentImageIndex - 1);
                        }
                      }}
                      sx={{
                        width: '40px',
                        height: '40px',
                        background: currentImageIndex > 0 ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.5)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: currentImageIndex > 0 ? 'pointer' : 'not-allowed',
                        transition: 'all 0.3s ease',
                        '&:hover': currentImageIndex > 0 ? {
                          background: 'rgba(255,255,255,1)',
                          transform: 'scale(1.1)'
                        } : {}
                      }}
                    >
                      <ArrowBackIcon sx={{ color: '#333', fontSize: '18px' }} />
                    </Box>
                    <Box 
                      onClick={(e) => {
                        e.stopPropagation();
                        if (currentImageIndex < availableImages.length - 1) {
                          setCurrentImageIndex(currentImageIndex + 1);
                        }
                      }}
                      sx={{
                        width: '40px',
                        height: '40px',
                        background: currentImageIndex < availableImages.length - 1 ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.5)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: currentImageIndex < availableImages.length - 1 ? 'pointer' : 'not-allowed',
                        transition: 'all 0.3s ease',
                        '&:hover': currentImageIndex < availableImages.length - 1 ? {
                          background: 'rgba(255,255,255,1)',
                          transform: 'scale(1.1)'
                        } : {}
                      }}
                    >
                      <ArrowForwardIcon sx={{ color: '#333', fontSize: '18px' }} />
                    </Box>
                  </Box>
                </Box>

                {/* Destination Details */}
                <Box sx={{
                  flex: { xs: '0 0 auto', lg: 1 }, // Don't stretch on small screens
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1.5,
                  width: '100%',
                  justifyContent: 'flex-start',
                  alignSelf: { xs: 'center', lg: 'stretch' }, // Center on small screens, stretch on large
                  minHeight: { lg: 0 } // Allow flex to control height
                }}>
                  <Box sx={{ flex: '0 0 auto' }}>
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        fontWeight: 700,
                        fontSize: { xs: '1rem', sm: '1rem', md: '1.2rem' },
                        color: '#000',
                        mb: 1
                      }}
                    >
                      {trending_trips[currentDestinationIndex].output_json?.hero?.title || 'Destination'}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: '0.75rem', sm: '0.75rem', md: '0.85rem' },
                        color: '#64748b',
                        lineHeight: 1.4,
                        textAlign: 'justify',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden'
                      }}
                    >
                      {trending_trips[currentDestinationIndex].cardDescription || 'Explore this amazing destination'}
                    </Typography>
                  </Box>

                  <Button
                    onClick={() => {
                      navigateToGuide(trending_trips[currentDestinationIndex].category, trending_trips[currentDestinationIndex].output_json);
                    }}
                    variant="contained"
                    sx={{
                      background: '#000',
                      color: '#fff',
                      borderRadius: 2,
                      mt: 0.5, // Small margin after description
                      mb: 0,
                      px: 2,
                      py: 0.5,
                      fontWeight: 600,
                      fontSize: { xs: '0.75rem', sm: '0.75rem', md: '0.8rem' },
                      textTransform: 'none',
                      alignSelf: 'flex-start',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      '&:hover': {
                        background: '#333',
                        boxShadow: '0 6px 16px rgba(0,0,0,0.2)'
                      }
                    }}
                  >
                    Explore {trending_trips[currentDestinationIndex].output_json?.hero?.title || 'Destination'} <ArrowForwardIcon sx={{ fontSize: '1rem', ml: 0.5 }} />
                  </Button>

                  {/* Related Images - Bigger Section */}
                  <Box sx={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column', mt: 1.5, minHeight: 0 }}>
                    <Typography
                      sx={{
                        fontSize: { xs: '0.9rem', sm: '0.9rem', md: '1.1rem' },
                        fontWeight: 700,
                        color: '#000',
                        mb: { xs: 1, sm: 1, md: 1.5 },
                        flex: '0 0 auto'
                      }}
                    >
                      More Images
                    </Typography>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
                      gap: { xs: 1, sm: 1, md: 2 },
                      width: '100%',
                      flex: 1,
                      minHeight: 0,
                      alignContent: 'stretch',
                      alignItems: 'stretch'
                    }}>
                      {availableImages.slice(0, 4).map((image, index) => (
                        <Box
                          key={index}
                          onClick={() => setCurrentImageIndex(index)}
                          sx={{
                            width: '100%',
                            aspectRatio: '1.029', // Maintain aspect ratio for right side images (same as left)
                            borderRadius: 3,
                            overflow: 'hidden',
                            cursor: 'pointer',
                            border: currentImageIndex === index ? '0.8px solid #000' : '0.8px solid #e0e0e0',
                            transition: 'all 0.3s ease',
                            position: 'relative',
                            '&:hover': {
                              '& img': {
                                transform: 'scale(1.1)',
                                transition: 'transform 0.3s ease'
                              }
                            }
                          }}
                        >
                          <YovoImage
                            src={image}
                            alt={trending_trips[currentDestinationIndex]?.output_json?.hero?.title || trending_trips[currentDestinationIndex]?.destination || ''}
                            width={160}
                            height={155}
                            sx={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Box>



        {/* Main Content Area */}

      {chatbotOpen && (
      <Suspense fallback={null}>
      <MobileChatbotOverlay
        open={chatbotOpen}
        setOpen={setChatbotOpen}
        sidebarOnMd={showHomepageChatbotSidebar}
      />
      </Suspense>
      )}

      {/* Unified homepage popup — conv fee promo + campaign modals in one carousel */}
      {/*<HomepagePopup*/}
      {/*  pathname={location.pathname}*/}
      {/*  isAuthenticated={isAuthenticated}*/}
      {/*  campaigns={homepageCampaigns}*/}
      {/*  status={homepageCampaignStatus}*/}
      {/*  viewport={homepageCampaignViewport}*/}
      {/*  product={homepageCampaignProduct}*/}
      {/*  onNavigate={homepageCampaignNavigate}*/}
      {/*/>*/}

      {/* Regional Settings Modal */}
      <MountWhenOpened open={regionalSettingsOpen}>
      <RegionalSettingsModal
        open={regionalSettingsOpen}
        onClose={() => setRegionalSettingsOpen(false)}
        onSave={(settings) => {
          console.log('✅ Regional settings saved:', settings);
          
          // Clear all flight-related caches to force new API calls with new currency
          // 1. Clear in-memory flight cache
          if (window.flightCache) {
            window.flightCache.clear();
          }
          
          // 2. Clear sessionStorage cache for flight results
          try {
            const sessionKeys = Object.keys(sessionStorage);
            sessionKeys.forEach(key => {
              // Clear flight search cache entries
              if (key.startsWith('flight_search_') || 
                  key.startsWith('flight_results_') ||
                  key.startsWith('multicity_flight_') ||
                  key.startsWith('historical_prices_')) {
                sessionStorage.removeItem(key);
              }
            });
            console.log('✅ Cleared flight search cache from sessionStorage');
          } catch (error) {
            console.error('❌ Error clearing sessionStorage cache:', error);
          }
          
          // 3. Dispatch a custom event to notify other components about currency change
          // This allows FlightSelect and other components to react to currency changes
          window.dispatchEvent(new CustomEvent('currencyChanged', { 
            detail: { currency: settings.currency } 
          }));
          
          console.log(`✅ Currency changed to ${settings.currency}. All caches cleared. New searches will use the new currency.`);
        }}
      />
      </MountWhenOpened>

      {(loginModalOpen || signupModalOpen) && (
      <Suspense fallback={null}>
      {loginModalOpen && (
      <LoginModal
        open
        onClose={handleCloseLoginModal}
        onSwitchToSignup={handleSwitchToSignup}
      />
      )}
      {signupModalOpen && (
      <SignupModal
        open
        onClose={handleCloseSignupModal}
        onSwitchToLogin={() => {
          setSignupModalOpen(false);
          setLoginModalOpen(true);
        }}
      />
      )}
      </Suspense>
      )}

      {/* Trending internation destination Section */}
      <NearViewport sectionId="global-hotspots-section">
      <Box 
        id="global-hotspots-section"
        sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        mt: 2,
        mb: 2,
        contentVisibility: 'auto',
        containIntrinsicSize: 'auto 600px',
        paddingLeft: { 
          xs: '16px', 
          sm: '16px', 
          md: 'clamp(20px, 1.25vw, 40px)',
          lg: 'clamp(24px, 1.25vw, 48px)'
        },
        paddingRight: { 
          xs: '16px', 
          sm: '16px', 
          md: 'clamp(20px, 1.25vw, 40px)',
          lg: 'clamp(24px, 1.25vw, 48px)'
        }
      }}>
        <Box sx={{
          width: '100%',
          maxWidth: {
            xs: '100%',     // Mobile: full width
            sm: '100%',     // Small: full width
            md: '1200px',   // Medium: 1200px - matches red bg
            lg: '1400px',   // Large: 1400px - matches red bg
            xl: '1600px'    // Extra large: 1600px - matches red bg
          },
          display: 'flex',
          mx: 'auto', // Center to match red bg alignment
          py: { xs: '20px', sm: '20px', md: '40px' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: '16px', sm: '16px', md: '24px' },
          alignSelf: 'stretch',
          background: '#F5F5F7',
          borderRadius: 3
        }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: '10px', sm: '10px', md: '16px' },
          alignSelf: 'stretch',
          borderRadius: '16px'
        }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
             <Box component="img" src={airplane_icon} sx={{
               width: { xs: '40px', sm: '40px', md: '60px' },
               height: { xs: '40px', sm: '40px', md: '60px' }
             }} />
            <Box>
                      <Typography sx={{
                color: 'var(--Neutrals-base-black, #20202A)',
                fontFamily: HOST_GROTESK_FAMILY,
                fontSize: { xs: '20px', sm: '20px', md: '28px' },
                fontWeight: 700,
                lineHeight: { xs: '28px', sm: '28px', md: '36px' }
              }}>
                {sectionMeta[2]?.title || 'Bucket List Journeys'}
              </Typography>
              <Typography sx={{
                width: '100%',
                maxWidth: '550px',
                color: '#6C6C6C',
                fontFamily: HOST_GROTESK_FAMILY,
                fontSize: '14px',
                fontWeight: 400,
                opacity: 0.75
              }}>
                {sectionMeta[2]?.subtitle || 'Experience breathtaking luxury escapes and once-in-a-lifetime destinations.'}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          className="homepage-destination-carousel"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: { xs: 1, sm: 1, md: 1.5 },
            width: '100%',
            alignSelf: 'stretch',
            minWidth: 0,
            overflow: 'hidden',
            boxSizing: 'border-box',
          }}
        >
          <IconButton
            onClick={() => scrollHomepageCarouselByOneCard('trending-destinations-scroll', -1)}
            aria-label="Scroll destinations left"
            sx={homepageCarouselArrowIconButtonSx}
          >
            <ArrowBackIcon sx={{ color: '#0D0D0D', fontSize: '20px' }} />
          </IconButton>

          <Box
            id="trending-destinations-scroll"
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: { xs: '8px', sm: '8px', md: '20px', lg: '20px' },
              flex: 1,
              minWidth: 0,
              overflowX: 'auto',
              overflowY: 'hidden',
              WebkitOverflowScrolling: 'touch',
              overscrollBehaviorX: 'contain',
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
              boxSizing: 'border-box',
            }}
          >
            {<WindowedCarouselTrack
              items={trending_international_destinations}
              trackId="trending-destinations-scroll"
              layout="percent"
              onOpen={openDestinationGuide}
            />}
          </Box>

          <IconButton
            onClick={() => scrollHomepageCarouselByOneCard('trending-destinations-scroll', 1)}
            aria-label="Scroll destinations right"
            sx={homepageCarouselArrowIconButtonSx}
          >
            <ArrowForwardIcon sx={{ color: '#0D0D0D', fontSize: '20px' }} />
          </IconButton>
        </Box>
        </Box>
      </Box>

      </NearViewport>

      {/* Weekend Getaway Collection Section */}
      <NearViewport sectionId="weekend-collection-section">
      <Box 
        id="weekend-collection-section"
        sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        mt: 2,
        mb: 2,
        contentVisibility: 'auto',
        containIntrinsicSize: 'auto 600px',
        paddingLeft: { 
          xs: '16px', 
          sm: '16px', 
          md: 'clamp(20px, 1.25vw, 40px)',
          lg: 'clamp(24px, 1.25vw, 48px)'
        },
        paddingRight: { 
          xs: '16px', 
          sm: '16px', 
          md: 'clamp(20px, 1.25vw, 40px)',
          lg: 'clamp(24px, 1.25vw, 48px)'
        }
      }}>
        <Box sx={{
          width: '100%',
          maxWidth: {
            xs: '100%',     // Mobile: full width
            sm: '100%',     // Small: full width
            md: '1200px',   // Medium: 1200px - matches red bg
            lg: '1400px',   // Large: 1400px - matches red bg
            xl: '1600px'    // Extra large: 1600px - matches red bg
          },
          display: 'flex',
          mx: 'auto', // Center to match red bg alignment
          py: { xs: '20px', sm: '20px', md: '40px' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: '16px', sm: '16px', md: '24px' },
          alignSelf: 'stretch',
          background: '#F5F5F7',
          borderRadius: 3
        }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: '10px', sm: '10px', md: '16px' },
          alignSelf: 'stretch',
          borderRadius: '16px'
        }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
             <Box component="img" src={weekend_getaways_icon} sx={{
               width: { xs: '40px', sm: '40px', md: '60px' },
               height: { xs: '40px', sm: '40px', md: '60px' },
               gap: '20px'
             }} />
            <Box>
                      <Typography sx={{
                color: 'var(--Neutrals-base-black, #20202A)',
                fontFamily: HOST_GROTESK_FAMILY,
                fontSize: { xs: '20px', sm: '20px', md: '29px' },
                fontWeight: 700,
                lineHeight: { xs: '28px', sm: '28px', md: '36px' }
              }}>
                {sectionMeta[3]?.title || 'Tropical Paradise Escapes'}
              </Typography>
              <Typography sx={{
                width: '100%',
                maxWidth: '550px',
                color: '#6C6C6C',
                fontFamily: HOST_GROTESK_FAMILY,
                fontSize: '14px',
                fontWeight: 400,
                opacity: 0.75
              }}>
                {sectionMeta[3]?.subtitle || 'Unwind at stunning beaches, island hideaways, and serene coastal destinations.'}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          className="homepage-destination-carousel"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: { xs: 1, sm: 1, md: 1.5 },
            width: '100%',
            alignSelf: 'stretch',
            minWidth: 0,
            overflow: 'hidden',
            boxSizing: 'border-box',
          }}
        >
          <IconButton
            onClick={() => scrollHomepageCarouselByOneCard('weekend-collection-scroll', -1)}
            aria-label="Scroll weekend collection left"
            sx={homepageCarouselArrowIconButtonSx}
          >
            <ArrowBackIcon sx={{ color: '#0D0D0D', fontSize: '20px' }} />
          </IconButton>

          <Box
            id="weekend-collection-scroll"
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: { xs: '8px', sm: '8px', md: '20px', lg: '20px' },
              flex: 1,
              minWidth: 0,
              overflowX: 'auto',
              overflowY: 'hidden',
              WebkitOverflowScrolling: 'touch',
              overscrollBehaviorX: 'contain',
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
              boxSizing: 'border-box',
            }}
          >
          {<WindowedCarouselTrack
              items={weekend_getaways}
              trackId="weekend-collection-scroll"
              layout="fixed"
              onOpen={openDestinationGuide}
            />}
          </Box>

          <IconButton
            onClick={() => scrollHomepageCarouselByOneCard('weekend-collection-scroll', 1)}
            aria-label="Scroll weekend collection right"
            sx={homepageCarouselArrowIconButtonSx}
          >
            <ArrowForwardIcon sx={{ color: '#0D0D0D', fontSize: '20px' }} />
          </IconButton>
        </Box>
        </Box>
      </Box>

      </NearViewport>

      {/* Weekend Getaways Section */}
      <NearViewport sectionId="visa-free-wonders-section">
      <Box 
        id="visa-free-wonders-section"
        sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        mt: 2,
        mb: 2,
        contentVisibility: 'auto',
        containIntrinsicSize: 'auto 600px',
        paddingLeft: { 
          xs: '16px', 
          sm: '16px', 
          md: 'clamp(20px, 1.25vw, 40px)',
          lg: 'clamp(24px, 1.25vw, 48px)'
        },
        paddingRight: { 
          xs: '16px', 
          sm: '16px', 
          md: 'clamp(20px, 1.25vw, 40px)',
          lg: 'clamp(24px, 1.25vw, 48px)'
        }
      }}>
        <Box sx={{
          width: '100%',
          maxWidth: {
            xs: '100%',     // Mobile: full width
            sm: '100%',     // Small: full width
            md: '1200px',   // Medium: 1200px - matches red bg
            lg: '1400px',   // Large: 1400px - matches red bg
            xl: '1600px'    // Extra large: 1600px - matches red bg
          },
          display: 'flex',
          mx: 'auto', // Center to match red bg alignment
          py: { xs: '20px', sm: '20px', md: '40px' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: '16px', sm: '16px', md: '24px' },
          alignSelf: 'stretch',
          background: '#F5F5F7',
          borderRadius: 3
        }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: '10px', sm: '10px', md: '16px' },
          alignSelf: 'stretch',
          borderRadius: '16px'
        }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
             <Box component="img" src={visa_free_icon} sx={{
               width: { xs: '40px', sm: '40px', md: '60px' },
               height: { xs: '40px', sm: '40px', md: '60px' },
               gap: '20px'
             }} />
            <Box>
                      <Typography sx={{
                color: 'var(--Neutrals-base-black, #20202A)',
                fontFamily: HOST_GROTESK_FAMILY,
                fontSize: { xs: '20px', sm: '20px', md: '28px' },
                fontWeight: 700,
                lineHeight: { xs: '28px', sm: '28px', md: '36px' }
              }}>
                {sectionMeta[4]?.title || 'Into the Wild'}
              </Typography>
              <Typography sx={{
                width: '100%',
                maxWidth: '550px',
                color: '#6C6C6C',
                fontFamily: HOST_GROTESK_FAMILY,
                  fontSize: '14px',
                fontWeight: 400,
                opacity: 0.75
              }}>
                {sectionMeta[4]?.subtitle || 'Explore scenic mountains, adventure hotspots, and wildlife escapes.'}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          className="homepage-destination-carousel"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: { xs: 1, sm: 1, md: 1.5 },
            width: '100%',
            alignSelf: 'stretch',
            minWidth: 0,
            overflow: 'hidden',
            boxSizing: 'border-box',
          }}
        >
          <IconButton
            onClick={() => scrollHomepageCarouselByOneCard('visa-free-scroll', -1)}
            aria-label="Scroll visa-free destinations left"
            sx={homepageCarouselArrowIconButtonSx}
          >
            <ArrowBackIcon sx={{ color: '#0D0D0D', fontSize: '20px' }} />
          </IconButton>

          <Box
            id="visa-free-scroll"
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: { xs: '8px', sm: '8px', md: '20px', lg: '20px' },
              flex: 1,
              minWidth: 0,
              overflowX: 'auto',
              overflowY: 'hidden',
              WebkitOverflowScrolling: 'touch',
              overscrollBehaviorX: 'contain',
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
              boxSizing: 'border-box',
            }}
          >
          {<WindowedCarouselTrack
              items={visa_free_destinations}
              trackId="visa-free-scroll"
              layout="fixed"
              onOpen={openDestinationGuide}
            />}
          </Box>

          <IconButton
            onClick={() => scrollHomepageCarouselByOneCard('visa-free-scroll', 1)}
            aria-label="Scroll visa-free destinations right"
            sx={homepageCarouselArrowIconButtonSx}
          >
            <ArrowForwardIcon sx={{ color: '#0D0D0D', fontSize: '20px' }} />
          </IconButton>
        </Box>
        </Box>
      </Box>

      </NearViewport>

      {/* Find Things by Interest Section */}
      <NearViewport sectionId="seasons-finest-section">
      <Box 
        id="seasons-finest-section"
        sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        mt: 2,
        mb: 2,
        contentVisibility: 'auto',
        containIntrinsicSize: 'auto 600px',
        paddingLeft: { 
          xs: '16px', 
          sm: '16px', 
          md: 'clamp(20px, 1.25vw, 40px)',
          lg: 'clamp(24px, 1.25vw, 48px)'
        },
        paddingRight: { 
          xs: '16px', 
          sm: '16px', 
          md: 'clamp(20px, 1.25vw, 40px)',
          lg: 'clamp(24px, 1.25vw, 48px)'
        }
      }}>
        <Box sx={{
          width: '100%',
          maxWidth: {
            xs: '100%',     // Mobile: full width
            sm: '100%',     // Small: full width
            md: '1200px',   // Medium: 1200px - matches red bg
            lg: '1400px',   // Large: 1400px - matches red bg
            xl: '1600px'    // Extra large: 1600px - matches red bg
          },
          display: 'flex',
          mx: 'auto', // Center to match red bg alignment
          py: { xs: '20px', sm: '20px', md: '40px' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: '16px', sm: '16px', md: '24px' },
          alignSelf: 'stretch',
          background: '#F5F5F7',
          borderRadius: 3
        }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: '10px', sm: '10px', md: '16px' },
          alignSelf: 'stretch',
          borderRadius: '16px'
        }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
        <Box component="img" src={seasonal_icon} sx={{
               width: { xs: '40px', sm: '40px', md: '60px' },
               height: { xs: '40px', sm: '40px', md: '60px' },
               gap: '20px'
             }} />
            <Box>
                      <Typography sx={{
                color: 'var(--Neutrals-base-black, #20202A)',
                fontFamily: HOST_GROTESK_FAMILY,
                fontSize: { xs: '20px', sm: '20px', md: '28px' },
                fontWeight: 700,
                lineHeight: { xs: '28px', sm: '28px', md: '36px' }
              }}>
                {sectionMeta[5]?.title || 'Hidden Gems & Offbeat Escapes'}
              </Typography>
              <Typography sx={{
                width: '100%',
                maxWidth: '550px',
                color: '#6C6C6C',
                fontFamily: HOST_GROTESK_FAMILY,
                fontSize: '14px',
                fontWeight: 400,
                opacity: 0.75
              }}>
                {sectionMeta[5]?.subtitle || 'Discover underrated destinations and unique cultural treasures.'}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          className="homepage-destination-carousel"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: { xs: 1, sm: 1, md: 1.5 },
            width: '100%',
            alignSelf: 'stretch',
            minWidth: 0,
            overflow: 'hidden',
            boxSizing: 'border-box',
          }}
        >
          <IconButton
            onClick={() => scrollHomepageCarouselByOneCard('seasons-finest-scroll', -1)}
            aria-label="Scroll seasonal destinations left"
            sx={homepageCarouselArrowIconButtonSx}
          >
            <ArrowBackIcon sx={{ color: '#0D0D0D', fontSize: '20px' }} />
          </IconButton>

          <Box
            id="seasons-finest-scroll"
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: { xs: '8px', sm: '8px', md: '20px', lg: '20px' },
              flex: 1,
              minWidth: 0,
              overflowX: 'auto',
              overflowY: 'hidden',
              WebkitOverflowScrolling: 'touch',
              overscrollBehaviorX: 'contain',
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
              boxSizing: 'border-box',
            }}
          >
          {<WindowedCarouselTrack
              items={seasonal_destinations}
              trackId="seasons-finest-scroll"
              layout="fixed"
              onOpen={openDestinationGuide}
            />}
          </Box>

          <IconButton
            onClick={() => scrollHomepageCarouselByOneCard('seasons-finest-scroll', 1)}
            aria-label="Scroll seasonal destinations right"
            sx={homepageCarouselArrowIconButtonSx}
          >
            <ArrowForwardIcon sx={{ color: '#0D0D0D', fontSize: '20px' }} />
          </IconButton>
        </Box>
        </Box>
      </Box>

      </NearViewport>

      {/* Testimonials */}
      <Box
        component="section"
        aria-label="Customer testimonials"
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          background: 'linear-gradient(180deg, #FAFBFC 0%, #F3F4F6 50%, #FAFBFC 100%)',
          mt: 2,
          py: { xs: '20px', sm: '20px', md: '40px' },
          paddingLeft: {
            xs: '16px',
            sm: '16px',
            md: 'clamp(20px, 1.25vw, 40px)',
            lg: 'clamp(24px, 1.25vw, 48px)',
          },
          paddingRight: {
            xs: '16px',
            sm: '16px',
            md: 'clamp(20px, 1.25vw, 40px)',
            lg: 'clamp(24px, 1.25vw, 48px)',
          },
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xs: '100%',
              sm: '100%',
              md: '1200px',
              lg: '1400px',
              xl: '1600px',
            },
            mx: 'auto',
          }}
        >
          <Suspense fallback={null}>
            <TestimonialsSection variant="homepage" id="homepage-testimonials" />
          </Suspense>
        </Box>
      </Box>

      {/* YovoTrip Promise + FAQ Section */}
      <Box 
        component="section" 
        className="homepage-faq-section" 
        aria-labelledby="homepage-faq-title" 
        sx={{ 
          background: FAQ_COLOR.canvas,
          pt: 0,
          pb: { xs: 6, md: 10 },
        }}
      >
        {/* The YovoTrip Promise - Premium Trust Cards + App Banner */}
        <Suspense fallback={null}>
        <FAQTrustStrip 
          items={FAQ_TRUST_ITEMS.homepage} 
          variant="homepage" 
          showAppBanner={true}
        />
        
        <FAQSection
          faqs={HOME_FAQS}
          variant="homepage"
          title="Frequently Asked Questions"
          subtitle="Everything you need to know before booking with YovoTrip."
          titleId="homepage-faq-title"
          defaultOpen={0}
          maxItems={HOME_FAQ_PREVIEW_COUNT}
          showViewAll={true}
          viewAllLink="/faqs"
          viewAllText="View all FAQs"
        />
        </Suspense>
        
        {/* FAQ Schema for SEO */}
        <FAQJsonLd faqs={HOME_FAQS} pageName="YovoTrip FAQs" />
      </Box>
        </Box>

      {/* Footer */}
      <Suspense fallback={null}>
        <GlobalFooter variant="full" />
      </Suspense>

      {/* Mobile bottom nav — portaled to document.body; render after page content */}
      <MobileBottomNav
        assistActive={chatbotOpen}
        onAssistClick={(initialMessage) => {
          if (initialMessage) window.chatbotInitialMessage = initialMessage;
          setChatbotOpen(true);
        }}
        onDismissAssist={() => setChatbotOpen(false)}
      />

      </Box>{/* end inner flex container (sticky header containing block) */}
      </Box>{/* end outer wrapper */}
      </>
    // </Box>
  );
};

export default Homepage;
